import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import BooleanField from '../../../_common/platform/tsx/BooleanField';
import NumberField from '../../../_common/platform/tsx/NumberField';
import StringField from '../../../_common/platform/tsx/StringField';
import UtcOffsetField from '../../../_common/platform/tsx/UtcOffsetField';
import RadioGroupFieldComponent, { IRadioGroupFieldItem, IRadioGroupFieldOptions } from './RadioGroupField';

import { IIntervalParameters, IIntervals } from '../../../_common/platform/ts/AqlUtility';
import { getPopoverStyle, explainAttributeType } from '../../../_common/platform/ts/Utilities';

import {
    convertTimeValueAsDateToString,
    evalUsingIntervals,
    formatDateForIntervalSelect,
    getTimeZoneName,
    isFiscalTimePeriod,
    isTypeOfAnyDate,
    isTypeOfDateOrDatetime,
    isTypeOfTime,
    ITimeZone,
    TimeDisplayFormat,
    TimeDisplayFormatShort,
    TimeValueFormat,
    useDateTimeIntervalType
} from '../../../_common/platform/ts/DateTimeFunctions';

import {
    DiscreteIntervals,
    DiscreteIntervalsKind,
    DiscreteIntervalsKind_toString
} from '../../../_common/platform/tsx/DiscreteIntervals';

import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';

import {
    TIME_PART_ELEMENTS,
    TIME_PERIOD_ELEMENTS,
    TIME_INTERVAL_ELEMENTS,
    ATTRIBUTE_TYPES
} from '../../../_common/platform/ts/ConfigurationConstants';

import { themeVars } from '../../../pdc-platform/src/ts/themes/themeConstants';
import * as Globalization from '../../../_common/platform/ts/Globalization';
import { IValuesCollection } from '../../../_common/platform/ts/appTheme';
import { MappingType } from '../ts/Interfaces';
import { ParameterField } from './ParameterField';
import SelectField, { ITypeNameElement, createSelectFieldOptions } from './SelectField';
import { VARIABLE_FISCAL_MONTH } from './filtering/Constants';

const moment = require('pdc-platform-moment');
const Globalize = require('pdc-platform-Globalize');
//LL: 16.12.18:
//const timeInfinityMinus = '00:00:00';
const timeInfinity = '24:00:00';

//LL: 21.02.19: styleDescr move here, leave as style, not class   Only color, in the future customize by Theme
const colorDescr = '#999999';
const styleDescr: React.CSSProperties = { color: colorDescr };

export interface IMappingValue {
    mappingType: MappingType;
    mappingName: string;
}

export type ImageMappingModeType = 'imageValue' | 'onlyImage'; //LL: 26.01.21: here from DataEdit Widget

interface IMappingValue_Internal extends IMappingValue {
    mappingObj: any;
}

function getOptions_name(
    list: {
        type: string;
        name: string;
    }[]
) {
    return _.map(list, (obj) => {
        return (
            <option key={obj.type.toString()} title={obj.type.toString()} value={obj.type}>
                {obj.name}
            </option>
        );
    });
}

function createFiscalMonthElement(
    timePart: string,
    value: number,
    defaultValue: number,
    elemClassName: string,
    type: string,
    onChange: (value: string) => void
) {
    let result: React.JSX.Element;

    if (type !== 'time') {
        if (isFiscalTimePeriod(timePart)) {
            let months: ITypeNameElement[] = [];

            for (let k = 1; k <= 12; k++) {
                months.push({
                    type: k.toString(),
                    name: Globalization.getMonthName_Wide(k)
                });
            }

            months.push({
                type: -1,
                name: VARIABLE_FISCAL_MONTH
            });

            const optionsStartMonth = createSelectFieldOptions(months);

            if (value == null) {
                value = defaultValue;
            }

            result = (
                <div className={elemClassName}>
                    <ParameterField
                        title={'Fiscal First Month'}
                        showInheritedIcon={value === defaultValue}
                        clearable={true}
                        showClearIcon={value !== defaultValue}
                        onClear={() => {
                            onChange(null);
                        }}
                    >
                        <SelectField value={value != null ? value.toString() : null} onChange={onChange}>
                            {optionsStartMonth}
                        </SelectField>
                    </ParameterField>
                </div>
            );
        }
    }

    return result;
}

function validateRegularIntervals(value, type: string) {
    let errors = [];

    if (value != null && value.numberIntervals != null) {
        if (value.numberIntervals.intervalLength < 0) {
            errors.push('Interval Length value should be a not negative number.');
        }

        if (value.numberIntervals.intervalLength == 0 && value.numberIntervals.normValue != 0) {
            errors.push('Interval Length value should not be 0.');
        }
    }

    if (value != null && value.timeIntervals != null) {
        if (type !== 'time') {
            let val = moment(value.timeIntervals.normDate); //VR: moment is RULES!!!  Globalize must die!

            if (val.isValid() == true && val.year() <= 2100 && val.year() >= 1800) {
            } else {
                errors.push("Invalid 'Norm Date' value: it should be Date or Datetime.");
            }
        } else {
            let D = Globalize.parseDate(value.timeIntervals.normDate, {
                raw: TimeValueFormat
            });

            if (D == null) {
                D = Globalize.parseDate(value.timeIntervals.normDate, {
                    raw: TimeDisplayFormat
                });
            }
            if (D == null) {
                D = Globalize.parseDate(value.timeIntervals.normDate, {
                    raw: TimeDisplayFormatShort
                });
            }
            if (D == null) {
                errors.push("Invalid 'Norm Time' value: it should be Time.");
            }
        }
    }

    return errors;
}

function validateUserDefinedIntervals(value, type: string) {
    let valid = DiscreteIntervals.validateDiscreteIntervals(value, type);
    return valid;
}

function validateWhole(value, type: string) {
    let errors = [];

    //LL: UserDefined and TimeParts cannot be together
    if (value.useIntervalType === useDateTimeIntervalType.useUserDefined) {
        if (value.timePart != null && value.timePart != 'none') {
            errors.push('User Defined Intervals and TimeParts are mutually exclusive');
        }
    }

    let errorsRegularIntervals = validateRegularIntervals(value, type);
    let hasErrorRegularIntervals = errorsRegularIntervals.length > 0;

    if (hasErrorRegularIntervals === true) {
        errors.push('There are errors in Regular Intervals');
    }

    let validUserDefinedIntervals = validateUserDefinedIntervals(value, type);

    if (validUserDefinedIntervals !== true) {
        errors.push('There are errors in User Defined Intervals');
    }

    return errors;
}

function getIntervalPlaceholderValue(left, right, type: string, inHTML: boolean) {
    // left can be null, -Infinity,  right can be Infinity
    let rightStr: any = right;

    if (type === 'time') {
        rightStr = rightStr !== Infinity ? convertTimeValueAsDateToString(rightStr) : timeInfinity;
    } else {
        rightStr = rightStr.toString();
    }

    //  '\u2264' <=   '\u2265'  UTF-16(hex) 0x2265  UTF-8 e289a5 &ge; ≥ >=     \u003e >
    //   https://mathiasbynens.be/notes/javascript-escapes
    //      UTF-8 (hex)	0xE2 0x89 0xA5 (e289a5)   '\u{1d306}' '\u{e289a5}'
    //     (The unicode for ≥ is "U+ 2265".)

    // https://stackoverflow.com/questions/12140003/ascii-code-for-less-than-or-equal-to
    //   The character ≤ isn't in the ASCII table. However, there are several ways to embed it in HTML.
    //   Firstly, using HTML entities: either &le;, &#8804;, or &#x2264.
    //     Just place this code in your HTML where you want the ≤ symbol to be.
    //   Alternatively, ensure that your html file is utf8 encoded, and include
    //    the meta tag <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" /> in the <head> of your document.
    //    You can then copy and paste the ≤ character directly into your document.

    //  He:  !!!
    //  I always just underline < and > which are standard keyboard characters.
    //  It may be a little clugey, but it works, and it saves remembering numbers.

    //LL:  won't work, Labels are returned by backend as values !!!  Suppose, they are converted (truncated ?) to ASCII ?

    //   https://pixelplus.ru/samostoyatelno/stati/vnutrennie-faktory/tablica-simvolov-unicode.html
    //   https://unicode-table.com/ru/
    let leftStr: any = left;

    if (leftStr == null || leftStr === -Infinity) {
        leftStr = '\u003C'; // "<";
    } else {
        if (type === 'time') {
            leftStr = convertTimeValueAsDateToString(leftStr);
        } else {
            leftStr = leftStr.toString();
        }
        if (right === Infinity) {
            //leftStr = '\u2265' + leftStr;  //  >=
            leftStr = (inHTML ? '\u2265' : '>=') + leftStr; //  >=   OK
            //leftStr = (inHTML ? '\u2265' : '≥')  + leftStr;  //  >=  NO just =

            //leftStr = (inHTML ? '\uD834\uDF06' : '\uD834\uDF06')  + leftStr;
            rightStr = '';
        } else {
            //LL: case when only one value, not interval:
            if (type === 'i' && right - left <= 1) {
                //LL: here right != Infinity & left != -Infinity
                rightStr = '';
            } else {
                leftStr = leftStr + '-';
            }
        }
    }

    let placeholderValue = leftStr + rightStr;

    return placeholderValue;
}

function areCompatibleDataTypes(dt1: string, dt2: string, differDateAndDateTime: boolean) {
    switch (dt1) {
        //case chartConstants.dataTypes.undefDataType:
        case 'string':
        case 's':
            return dt2 === 's';
        case 'boolean':
        case 'b':
            return dt2 === 'b';
        case 'integer':
        case 'i':
            return dt2 === 'i';
        case 'real':
        case 'r':
        case 'number':
            //return dt2 === 'r';
            return dt2 === 'i' || dt2 === 'r';
        case 'datetime':
        case 'date':
            if (differDateAndDateTime) {
                return dt2 === dt1;
            } else {
                return dt2 === 'datetime' || dt2 === 'date';
            }
        case 'time':
            return dt2 === 'time';
        default:
            return dt2 === dt1;
    }
}

//  targetTypes is array of DiscreteIntervalsKind (enum from DiscreteIntervals) or null for any
//  dt1 - dataType from Predefined DiscreteMapping
//  dt2 - actual dataType
function isCompatibleMapping(
    isDiscrete: boolean,
    dt1: string,
    dt2: string,
    targetTypes?: number[],
    resultingType?: number
) {
    if (targetTypes != null) {
        if (_.indexOf(targetTypes, resultingType) < 0) {
            return false;
        }
    }

    return areCompatibleDataTypes(dt1, dt2, false);
}

function getMappingList(theme: IValuesCollection, mappingType: MappingType) {
    // see: export type MappingType = 'DiscreteMapping' | 'ColorScale';
    if (theme == null) {
        return null;
    }

    let themeFieldName: string;

    if (mappingType === 'AttributeMapping') {
        themeFieldName = themeVars.entityAttributeMapping;
    } else {
        themeFieldName = mappingType === 'DiscreteMapping' ? themeVars.discreteMapping_set : themeVars.color_scales_set;
    }

    return theme[themeFieldName];
}

class UserDefinedIntervals extends React.Component<
    {
        value: IIntervals;
        type: string;
        modePredefinedOrOwn?; // Is not used.
        themeObj: IValuesCollection;
        glob: IGlob;
        onChange(value: IIntervals, hasIntervalError?: boolean, useIntervalTypeChanged?: boolean): void;
    },
    {
        selectedPredefinedDiscreteMapping?: string;
        curPredefinedOrOwnMode;
        selectedPredefinedMappingValue: string;
    }
> {
    private references: {
        selectDiscreteMapping?: HTMLElement;
        selectPredefinedDiscreteMapping?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        let curPredefinedOrOwnMode = 'CreateOwn';
        let predefinedMapping: any = null;
        let predefinedMappingName: string = null;

        if (props.value != null) {
            if (props.value.modePredefinedOrOwn != null) {
                curPredefinedOrOwnMode = props.value.modePredefinedOrOwn;
            }
            if (props.value.predefinedMapping != null) {
                predefinedMapping = props.value.predefinedMapping;
                predefinedMappingName = predefinedMapping.mappingName;
            }
        }

        this.state = {
            selectedPredefinedDiscreteMapping: null,
            curPredefinedOrOwnMode: curPredefinedOrOwnMode,
            selectedPredefinedMappingValue: predefinedMappingName
        };
    }

    getValueCopy = () => {
        return this.props.value != null ? { ...this.props.value } : {};
    };

    handleDiscreteIntervalsChange = (value: IIntervals, hasIntervalError?: boolean) => {
        const obj = this.getValueCopy();

        if (value != null) {
            if (value.values != null) {
                obj.values = value.values.slice(0);
            } else {
                delete obj.values;
            }

            if (value.labels != null) {
                obj.labels = value.labels.slice(0);
            } else {
                delete obj.labels;
            }

            if (value.step != null) {
                obj.step = value.step;
            } else {
                delete obj.step;
            }
        } else {
            delete obj.values;
            delete obj.labels;
            delete obj.step;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj, hasIntervalError === true);
        }
    };

    //LL:  for UserDefinedIntervals - DiscreteMappings
    areCompatible(resultingType, dt1, dt2) {
        //  resultingType must be DiscreteIntervalsKind.label   At least now
        //  dt1 - dataType from Predefined DiscreteMapping
        //  dt2 - actual dataType
        if (resultingType != DiscreteIntervalsKind.label) {
            return false;
        }

        return areCompatibleDataTypes(dt1, dt2, true);
    }

    //LL: for UserDefinedIntervals - DiscreteMappings
    processApplyPredefinedDiscreteMapping = (e) => {
        e.stopPropagation();
        e.preventDefault();

        let selectedPredefinedDiscreteMapping = this.state.selectedPredefinedDiscreteMapping; //LL:   may be '', null

        if (selectedPredefinedDiscreteMapping == null || selectedPredefinedDiscreteMapping === '') {
            return;
        }

        let themeObj = this.props.themeObj;
        let themeFieldForDiscreteMappings = themeVars.discreteMapping_set;

        if (themeObj != null && themeFieldForDiscreteMappings != null) {
            let dmList = themeObj[themeFieldForDiscreteMappings];
            if (dmList != null && dmList.length > 0) {
                let dmObj = _.find(dmList, (obj) => {
                    return obj.name === selectedPredefinedDiscreteMapping;
                });
                //dmObj.discreteIntervals  { values: [], labels: [] }
                if (
                    dmObj != null &&
                    dmObj.discreteIntervals != null &&
                    dmObj.discreteIntervals.values != null &&
                    dmObj.discreteIntervals.values.length > 0
                ) {
                    //LL:  labels.len = values.len + 1

                    let obj = _.clone(this.props.value || {}); // obj: { values: [], labels: [] }
                    //let obj = _.clone(this.props.value || { values: [], labels: [] });  // obj: { values: [], labels: [] }
                    if (obj.values == null) {
                        obj.values = [];
                    }
                    if (obj.labels == null) {
                        obj.labels = [];
                    }

                    dmObj = $.extend(true, {}, dmObj); // copy
                    //  name, inherited - to remove them;   dataType -> dataTypePredefined
                    delete dmObj.inherited;
                    delete dmObj.disabled;
                    delete dmObj.name;
                    delete dmObj.dataType;
                    delete dmObj.resultingType;
                    //axisObjNew.namePredefined = axisObj.name;
                    //axisObjNew.dataTypePredefined = axisObj.dataType;

                    //dmObj.discreteIntervals  { values: [], labels: [] }

                    //  No, arrays inside:
                    //obj = $.extend(true, obj, axisObj);

                    //LL:  values order will be broken !!
                    //obj.values = value.values.slice(0);  NO
                    obj.values = obj.values.concat(dmObj.discreteIntervals.values);

                    //LL:  labels.len = values.len + 1
                    if (obj.labels.length == 0) {
                        obj.labels = obj.labels.concat(dmObj.discreteIntervals.labels);
                    } else {
                        let labels = _.map(obj.labels, function (a) {
                            return a;
                        });
                        let K = labels.length;

                        _.each(dmObj.discreteIntervals.labels, function (a, index) {
                            if (index === 0 && a !== '') {
                                labels[K - 1] = labels[K - 1] + ' ' + a;
                            } else {
                                labels.push(a);
                            }
                        });

                        obj.labels = labels;
                    }

                    if (obj.step == null && dmObj.discreteIntervals.step != null) {
                        obj.step = dmObj.discreteIntervals.step;
                    }

                    if (typeof this.props.onChange === 'function') {
                        //   validate is done later
                        //this.props.onChange(obj, true);
                        this.props.onChange(obj);
                    }
                }
            }
        }
    };

    //LL:  for UserDefinedIntervals - DiscreteMappings
    processDiscreteMappingChange = (e) => {
        let elem: any = this.references.selectDiscreteMapping;
        let val = elem.value;

        this.setState(
            _.extend(this.state, {
                selectedPredefinedDiscreteMapping: val
            })
        );
    };

    processPredefinedDiscreteMappingChange = (e) => {
        let elem: any = this.references.selectPredefinedDiscreteMapping;
        let val = elem.value; //LL: '' for not_set

        this.setState(
            _.extend(this.state, {
                selectedPredefinedMappingValue: val
            })
        );

        const obj = this.getValueCopy();

        if (val == null || val === '') {
            obj.predefinedMapping = null;
        } else {
            let curMappingType: MappingType = 'DiscreteMapping';
            obj.predefinedMapping = { mappingName: val, mappingType: curMappingType };
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj, null, true); //LL: 03.11.23: important: 3d param is "true" !!!
        }
    };

    handleOnPredefinedOrOwnModeChange = (val) => {
        const obj = this.getValueCopy();

        obj.modePredefinedOrOwn = val; // 'UsePredefined' / 'CreateOwn'

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj, null, true); //LL: 03.11.23: important: 3d param is "true" !!!
        }

        this.setState({ curPredefinedOrOwnMode: val });
    };

    render() {
        let value: IIntervals;
        let obj = this.props.value;

        if (obj == null) {
            //obj = { labels: [''], values: [] };
        } else {
            value = {};

            if (obj.values != null) {
                value.values = obj.values.slice(0);
            }
            if (obj.labels != null) {
                value.labels = obj.labels.slice(0);
            }
            if (obj.step != null) {
                value.step = obj.step;
            }
        }

        //LL: 19.11.19: for UserDefinedIntervals,  see similar in AxisList
        //   "Define Intervals or add Predefined from List":     [ btn Add]   [list]
        //          -- if DiscreteIntervals for current type and toLabel exist
        let predefinedIntervalsElem;
        //LL: 02.11.23: 'UsePredefined' / 'CreateOwn'
        let selectPredefinedDiscreteMappingElem;

        const themeObj = this.props.themeObj;
        const themeFieldForDiscreteMappings = themeVars.discreteMapping_set;

        if (themeObj != null && themeFieldForDiscreteMappings != null) {
            const dmList = themeObj[themeFieldForDiscreteMappings];

            if (dmList != null && dmList.length > 0) {
                //LL: must be only of the compatible data type !!
                const dmListReduced = _.filter(dmList, (dmObj) => {
                    return this.areCompatible(dmObj.resultingType, dmObj.dataType, this.props.type);
                });

                if (dmListReduced != null && dmListReduced.length > 0) {
                    let disabledApply = this.state.selectedPredefinedDiscreteMapping == null;
                    let applyPredefinedButtonVal = (
                        <button
                            disabled={disabledApply}
                            className="empty btn btn-default"
                            onClick={this.processApplyPredefinedDiscreteMapping}
                        >
                            {'Apply from Predefined Discrete Mapping'}
                        </button>
                    );

                    let options = _.map(dmListReduced, (item) => {
                        return (
                            <option key={item.name} value={item.name}>
                                {item.name}
                            </option>
                        );
                    });

                    // Warning: `value` prop on `select` should not be null.
                    // Consider using an empty string to clear the component or `undefined` for uncontrolled components.
                    let dmVal = this.state.selectedPredefinedDiscreteMapping || '';

                    if (this.state.selectedPredefinedDiscreteMapping == null) {
                        options.unshift(
                            <option key={' '} value={''} disabled={true}>
                                {'choose an item'}
                            </option>
                        );
                    }

                    let selectDiscreteMappingElem = (
                        <select
                            ref={(input) => {
                                this.references.selectDiscreteMapping = input;
                            }} //LL: 14.01.25
                            className="form-control"
                            onChange={this.processDiscreteMappingChange}
                            value={dmVal}
                        >
                            {options}
                        </select>
                    );

                    predefinedIntervalsElem = (
                        <div className="apply-predefined">
                            <div className="apply-predefined-button">
                                <span className="value">{applyPredefinedButtonVal}</span>
                            </div>
                            <div className="select-mapping">{selectDiscreteMappingElem}</div>
                        </div>
                    );

                    //==================================================
                    //LL: 02.11.23: 'UsePredefined' / 'CreateOwn'
                    let options2 = _.map(dmListReduced, (item) => {
                        return (
                            <option key={item.name} value={item.name}>
                                {item.name}
                            </option>
                        );
                    });
                    // Warning: `value` prop on `select` should not be null.
                    // Consider using an empty string to clear the component or `undefined` for uncontrolled components.
                    let pmVal = this.state.selectedPredefinedMappingValue || '';
                    //   { "&ltnot_set&gt" }
                    options2.unshift(
                        <option key={' '} value={''}>
                            {'<not_set>'}
                        </option>
                    );
                    let curPredefinedOrOwnMode = this.state.curPredefinedOrOwnMode;
                    let disabledUsePredefined = curPredefinedOrOwnMode !== 'UsePredefined';
                    //let disabledCreateOwn = curPredefinedOrOwnMode !== 'CreateOwn';
                    selectPredefinedDiscreteMappingElem = // 10 2 10 14
                        (
                            <select
                                ref={(input) => {
                                    this.references.selectPredefinedDiscreteMapping = input;
                                }}
                                className="form-control"
                                value={pmVal}
                                disabled={disabledUsePredefined}
                                onChange={this.processPredefinedDiscreteMappingChange}
                            >
                                {options2}
                            </select>
                        );
                }
            }
        }

        const rgItems: IRadioGroupFieldItem[] = [];
        const curPredefinedOrOwnMode = this.state.curPredefinedOrOwnMode;
        const disabledUsePredefined = curPredefinedOrOwnMode !== 'UsePredefined';
        const disabledCreateOwn = curPredefinedOrOwnMode !== 'CreateOwn';

        if (selectPredefinedDiscreteMappingElem == null) {
            selectPredefinedDiscreteMappingElem = <label>There are no suitable Discrete Mappings</label>;
        }

        let styleOwnMappingContainer: any = {};
        let styleUsePredefinedContainer: any = {};
        let starSymbol_OwnMapping = '';
        let starSymbol_UsePredefined = '';

        if (disabledCreateOwn) {
            //LL: backgroundColor or disable all or some upper empty div ? Most simple: don't show at all:
            //styleOwnMappingContainer.backgroundColor = 'gray'; //LL: bad, not whole
            styleOwnMappingContainer.display = 'none';

            //  ✱   https://www.piliapp.com/symbol/asterisk/
            if (value != null && value.values != null && value.values.length > 0) {
                starSymbol_OwnMapping = '✱ ';
            }
        }

        if (disabledUsePredefined) {
            styleUsePredefinedContainer.display = 'none';
            if (this.state.selectedPredefinedMappingValue != null) {
                starSymbol_UsePredefined = '✱ ';
            }
        }
        //   item.content;  //LL:  null or react element
        //LL: 07.11.23 starSymbol_UsePredefined, style={styleUsePredefinedContainer}
        rgItems.push({
            text: starSymbol_UsePredefined + 'Use Predefined Discrete Mapping',
            value: 'UsePredefined',
            content: (
                <div className="rg-item-container" style={styleUsePredefinedContainer}>
                    {selectPredefinedDiscreteMappingElem}
                </div>
            )
        });
        rgItems.push({
            text: starSymbol_OwnMapping + 'Create Own Mapping Intervals',
            value: 'CreateOwn',
            content: (
                <div className="rg-item-container" style={styleOwnMappingContainer}>
                    {predefinedIntervalsElem}
                    <div className="discreteIntervals-container">
                        <DiscreteIntervals
                            value={value}
                            type={this.props.type}
                            kind={DiscreteIntervalsKind.label}
                            useNullValueMapping={false}
                            themeObj={this.props.themeObj}
                            glob={this.props.glob}
                            onChange={this.handleDiscreteIntervalsChange}
                        />
                    </div>
                </div>
            )
        });

        const rgOptions: IRadioGroupFieldOptions = {
            name: 'RG_PredefinedOrOwnMode', //LL: needed to differ RadioGroup from other RadioGroups
            layout: 'vertical',
            items: rgItems
        };
        const styleUseMappingType: React.CSSProperties = {
            marginTop: '10px',
            marginBottom: '5px'
        };

        return (
            <div className="interval-select-component">
                <span style={styleDescr}>
                    {
                        'Discrete Intervals are useful if you want to do counting within a set of intervals \
                    which you can define yourself. As example you can group a delay into: OnTime, \
                    TooLate, VeryLate.'
                    }
                </span>

                <div className="PredefinedOrOwn-Container" style={styleUseMappingType}>
                    <RadioGroupFieldComponent
                        value={curPredefinedOrOwnMode}
                        options={rgOptions}
                        onChange={this.handleOnPredefinedOrOwnModeChange}
                    />
                </div>
            </div>
        );
    }
}

function getFiscalFirstMonthFromTheme(theme: IValuesCollection): number {
    if (theme != null) {
        let result = theme[themeVars.fiscalFirstMonth];

        if (typeof result === 'number') {
            return result;
        } else if (typeof result === 'string') {
            result = parseInt(result);

            return !isNaN(result) ? result : null;
        }
    }

    return null;
}

class TimeParts extends React.Component<
    {
        value: IIntervals;
        theme: IValuesCollection;
        type: string;

        onChange(value: IIntervals): void;
    },
    {}
> {
    private references: {
        timePartCtrl?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);
    }

    handleOnTimePartChange = (e) => {
        const valueCopy = $.extend(true, {}, this.props.value);
        let val = (this.references.timePartCtrl as HTMLInputElement).value;

        if (val === 'none') {
            delete valueCopy.timePart;
        } else {
            valueCopy.timePart = val;
        }

        this.handleValueChange(valueCopy);
    };

    handleOnTimePartStartMonthChange = (value: string) => {
        const valueCopy = $.extend(true, {}, this.props.value);

        if (value != null) {
            valueCopy.timePeriodStartMonth = parseInt(value, 10);
        } else {
            delete valueCopy.timePeriodStartMonth;
        }

        this.handleValueChange(valueCopy);
    };

    handleValueChange = (value) => {
        if (value.values == null) {
            value = _.extend(value, { labels: [''], values: [] });
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    render() {
        let optionsTimePart = getOptions_name(TIME_PART_ELEMENTS['dateTimeInterval']);

        if (this.props.type === 'date') {
            optionsTimePart = getOptions_name(TIME_PART_ELEMENTS['dateInterval']);
        }

        if (this.props.type === 'time') {
            optionsTimePart = getOptions_name(TIME_PART_ELEMENTS['timeInterval']);
        }

        const valueOrig = this.props.value || {};
        const defaultFirstMonth = getFiscalFirstMonthFromTheme(this.props.theme);
        const displayValTimePart = valueOrig.timePart ?? 'none';
        const elemFiscal_TimePart = createFiscalMonthElement(
            displayValTimePart,
            valueOrig.timePeriodStartMonth,
            defaultFirstMonth,
            'values-flex widthTimePeriod',
            this.props.type,
            this.handleOnTimePartStartMonthChange
        );

        return (
            <div>
                <span style={styleDescr}>
                    {
                        'Using TimePart is useful if you want to count an entity for a given \
                        time part.As example select time part to be Month to inspect the count for each month during the year.'
                    }
                </span>

                <div className="values-container-flex">
                    <div className="values-flex-first time-part">
                        <ParameterField title={'Time Part'}>
                            <select
                                ref={(input) => {
                                    this.references.timePartCtrl = input;
                                }}
                                className="form-control"
                                value={displayValTimePart}
                                onChange={this.handleOnTimePartChange}
                            >
                                {optionsTimePart}
                            </select>
                        </ParameterField>
                    </div>

                    {elemFiscal_TimePart}
                </div>
            </div>
        );
    }
}

function CalendarPeriods(props: {
    value: IIntervals;
    theme: IValuesCollection;
    type: string;
    glob: IGlob;

    onChange(value: IIntervals, hasIntervalError: boolean): void;
}) {
    const [value, setValue] = React.useState<IIntervals>(props.value || {});
    //const [hasIntervalError, setHasIntervalError] = React.useState(false); //EVG: This is set nowhere.

    React.useEffect(() => {
        const newValue = props.value || {};

        if (!compareObjects(value, newValue)) {
            setValue(newValue);
        }
    }, [JSON.stringify(props.value)]);

    const getDefaultTimePeriod = () => {
        return {
            timePeriod: 'none', // TIME_PERIOD_CONCEPT.timePeriods
            timePeriodStartMonth: getFiscalFirstMonthFromTheme(props.theme),
            timePeriodTimeZoneAnother: false, // default false - use TZ from theme, otherwise value from prop timePeriodTimeZone
            timePeriodTimeZone: null // object, as value from UtcOffsetField
        };
    };

    const makeValueCopy = () => {
        return $.extend(true, {}, value);
    };

    const handleOnTimePeriodChange = (value: string) => {
        const valueCopy = makeValueCopy();

        if (value === 'none') {
            delete valueCopy.timePeriods;
        } else {
            if (valueCopy.timePeriods == null) {
                valueCopy.timePeriods = getDefaultTimePeriod();
            }

            valueCopy.timePeriods.timePeriod = value;
        }

        handleValueChange(valueCopy);
    };

    const handleOnTimePeriodStartMonthChange = (value: string) => {
        const valueCopy = makeValueCopy();

        if (valueCopy.timePeriods == null) {
            valueCopy.timePeriods = getDefaultTimePeriod();
        }

        if (value != null) {
            valueCopy.timePeriods.timePeriodStartMonth = parseInt(value, 10);
        } else {
            delete valueCopy.timePeriods.timePeriodStartMonth;
        }

        handleValueChange(valueCopy);
    };

    const timePeriodTimeZoneChange = (value: ITimeZone) => {
        const valueCopy = makeValueCopy();

        if (valueCopy.timePeriods == null) {
            valueCopy.timePeriods = getDefaultTimePeriod();
        }

        valueCopy.timePeriods.timePeriodTimeZone = value;
        handleValueChange(valueCopy);
    };

    const timePeriodTimeZoneAnotherChange = (value: boolean) => {
        const valueCopy = makeValueCopy();

        if (valueCopy.timePeriods == null) {
            valueCopy.timePeriods = getDefaultTimePeriod();
        }

        valueCopy.timePeriods.timePeriodTimeZoneAnother = value;
        handleValueChange(valueCopy);
    };

    const handleValueChange = (value: IIntervals, hasIntervalError?: boolean) => {
        if (value.values == null) {
            value = _.extend(value, { labels: [''], values: [] });
        }

        setValue(value);

        if (typeof props.onChange === 'function') {
            props.onChange(value, hasIntervalError);
        }
    };

    const defaultFirstMonth = getFiscalFirstMonthFromTheme(props.theme);
    const { timePeriods } = value;

    let optionsTimePeriod = getOptions_name(TIME_PERIOD_ELEMENTS['timePeriods']);

    if (props.type === 'date') {
        optionsTimePeriod = getOptions_name(TIME_PERIOD_ELEMENTS['timePeriodsOnlyDate']);
    }

    if (props.type === 'time') {
        optionsTimePeriod = getOptions_name(TIME_PERIOD_ELEMENTS['timePeriodsOnlyTime']);
    }

    let displayValTimePeriod = 'none';
    let displayValTimePeriodTimeZone: ITimeZone;
    let displayValTimePeriodTimeZoneAnother = false;
    let displayValTimePeriodStartMonth = defaultFirstMonth;

    if (timePeriods != null) {
        if (timePeriods.timePeriod != null) {
            displayValTimePeriod = timePeriods.timePeriod;
        }

        if (timePeriods.timePeriodTimeZone != null) {
            displayValTimePeriodTimeZone = timePeriods.timePeriodTimeZone;
        }

        if (timePeriods.timePeriodTimeZoneAnother != null) {
            displayValTimePeriodTimeZoneAnother = timePeriods.timePeriodTimeZoneAnother;
        }

        if (timePeriods.timePeriodStartMonth != null) {
            displayValTimePeriodStartMonth = timePeriods.timePeriodStartMonth;
        }
    }

    //LL: don't use TimeZone Selector for "time" (decision LL & VR)
    let elemTimeZoneSelector: React.JSX.Element;

    if (props.type !== 'time') {
        let elemTimeZone: React.JSX.Element;

        if (displayValTimePeriodTimeZoneAnother === true) {
            elemTimeZone = (
                <div className="timeZone3">
                    <label>
                        <span>{'Time Zone'}</span>
                    </label>
                    <UtcOffsetField
                        value={displayValTimePeriodTimeZone}
                        glob={props.glob}
                        onChange={timePeriodTimeZoneChange}
                    />
                </div>
            );
        }

        elemTimeZoneSelector = (
            <div className="timeZone">
                <div className="timeZone2">
                    <BooleanField
                        value={displayValTimePeriodTimeZoneAnother}
                        title={'Set different Time Zone than in Theme'}
                        onChange={timePeriodTimeZoneAnotherChange}
                    />
                    {elemTimeZone}
                </div>
            </div>
        );
    }

    let calendarPeriodExplanationText =
        'Group DateTime values into Months/Quarters/Weeks/etc and return Start/Middle/End \
                        of the Period. Calculations are done in specified Time Zone.';

    if (props.type === 'time') {
        calendarPeriodExplanationText =
            'Group Time values into Hours/Minutes/Seconds and \
                        return Start/Middle/End of the Period.';
    }

    const elemFiscal = createFiscalMonthElement(
        displayValTimePeriod,
        displayValTimePeriodStartMonth,
        defaultFirstMonth,
        'values-flex widthTimePeriod',
        props.type,
        handleOnTimePeriodStartMonthChange
    );

    return (
        <div>
            <span style={styleDescr}>{calendarPeriodExplanationText}</span>

            <div className="values-container-flex">
                <div className="values-flex-first widthTimePeriod">
                    <ParameterField title={'Period'}>
                        <SelectField value={displayValTimePeriod} onChange={handleOnTimePeriodChange}>
                            {optionsTimePeriod}
                        </SelectField>
                    </ParameterField>
                </div>
                {elemFiscal}
            </div>

            {elemTimeZoneSelector}
        </div>
    );
}

const NORM_DATE = '2000-01-01 00:00:00';
const NORM_TIME = '00:00:00';

class DateTimeRegularInterval extends React.Component<any, any> {
    private references: {
        timeEntityCtrl?: HTMLSelectElement;
        intervalLengthCtrl?: HTMLSelectElement;
    } = {};

    constructor(props) {
        super(props);

        let valueOrig = this.props.value || {};
        let errors = validateRegularIntervals(valueOrig, this.props.type);
        this.state = { value: valueOrig, hasIntervalError: errors.length > 0 };
    }

    componentWillReceiveProps(nextProps) {
        if (!compareObjects(this.props.value, nextProps.value)) {
            this.setState({ value: nextProps.value });
        }
    }

    timeEntityChange = (e) => {
        let val = this.references.timeEntityCtrl.value;
        let obj = this.state.value;

        if (val === 'none') {
            delete obj.timeIntervals;
        } else if (obj.timeIntervals == null) {
            obj.timeIntervals = {
                timePart: val,
                intervalLength: 1,
                normDate: this.props.type === 'time' ? NORM_TIME : NORM_DATE
            };
        } else {
            obj.timeIntervals.timePart = val;
        }

        this.handleValueChange(obj, this.state.hasIntervalError);
    };

    timeIntervalChange = (e) => {
        let val: any = this.references.intervalLengthCtrl.value;
        let obj = this.state.value;

        val = parseInt(val);

        if (isNaN(val)) {
            val = 1;
        }
        if (obj.timeIntervals != null) {
            obj.timeIntervals.intervalLength = val;
            this.handleValueChange(obj, this.state.hasIntervalError);
        }
    };

    normDateChange = (value) => {
        let obj = this.state.value;
        let hasIntervalError = false;
        // let val = new Date(value);  VR: wrong,
        // if (val instanceof Date) { VR: WRONG checking =========================!!!!
        // let val = Globalize.parseDate(value, {raw: 'yyyy-MM-dd HH:mm:ss'}); VR: wrong: does not accept date!

        //LL: 27.09.18: process "time", VR sets new value always regardless of validation, so do the same
        if (obj.timeIntervals != null) {
            if (this.props.type === 'time') {
                let D = Globalize.parseDate(value, { raw: TimeValueFormat });

                if (D == null) {
                    D = Globalize.parseDate(value, { raw: TimeDisplayFormat });
                }
                if (D == null) {
                    D = Globalize.parseDate(value, {
                        raw: TimeDisplayFormatShort
                    });
                }
                if (D == null) {
                    hasIntervalError = true;
                }
                //else {
                //    obj.timeIntervals.normDate = value;
                //}
                obj.timeIntervals.normDate = value;
            } else {
                let val = moment(value); //VR: moment is RULES!!!  Globalize must die!
                obj.timeIntervals.normDate = value;

                //VR: wrong! we should not do it here, but only while generate AQL query!
                //obj.timeIntervals.normDate =  formatDate(value, this.props.locale.lang, this.props.locale.timeZone);

                if (val.isValid() == true && val.year() <= 2100 && val.year() >= 1800) {
                } else {
                    hasIntervalError = true;
                }
            }
        }
        this.handleValueChange(obj, hasIntervalError);
    };

    handleValueChange = (value, hasIntervalError) => {
        if (value.values == null) {
            value = _.extend(value, { labels: [''], values: [] });
        }

        this.setState({
            value: value,
            hasIntervalError: hasIntervalError
        });

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, hasIntervalError);
        }
    };

    getOptions = (list) => {
        //LL: text was  { obj.type }
        return _.map(list, (obj: any) => {
            return (
                <option key={obj.type} title={obj.name} value={obj.type}>
                    {obj.name}
                </option>
            );
        });
    };

    getOptionsNum = (timeInterval) => {
        let numArray = _.find(TIME_INTERVAL_ELEMENTS['dateTimeInterval'], function (item) {
            if (item.type === timeInterval) {
                return true;
            }
        });
        if (numArray == null) {
            // it is exception!!!
            let obj = '1';
            return [
                <option key={obj} title={obj} value={obj}>
                    {' '}
                    {obj}{' '}
                </option>
            ];
        }

        return _.map(numArray.num, function (num1) {
            let obj = num1.toString();
            return (
                <option key={obj} title={obj} value={obj}>
                    {obj}
                </option>
            );
        });
    };

    render() {
        let errors = validateRegularIntervals(this.state.value, this.props.type);
        let normDateText = 'Norm Date:';
        let normTimeTitle = '';

        if (this.props.type === 'time') {
            normDateText = 'Norm Time:';
            normTimeTitle = TimeDisplayFormat + ' or ' + TimeDisplayFormatShort;
        }

        let optionsTimeInterval = this.getOptions(TIME_INTERVAL_ELEMENTS['dateTimeInterval']);
        if (this.props.type === 'date') {
            optionsTimeInterval = this.getOptions(TIME_INTERVAL_ELEMENTS['dateInterval']);
        }
        if (this.props.type === 'time') {
            optionsTimeInterval = this.getOptions(TIME_INTERVAL_ELEMENTS['timeInterval']);
        }

        let timeIntervalArray = [
            //LL: so was by RYB
            { type: '1', name: '1' },
            { type: '2', name: '2' },
            { type: '3', name: '3' },
            { type: '4', name: '4' }
        ];
        let optionsNum = _.map(timeIntervalArray, function (obj) {
            return (
                <option key={obj.type} title={obj.name} value={obj.type}>
                    {obj.type}
                </option>
            );
        });
        let displayValTimeIntervals = 'none';
        let displayValIntervalLength = 1;
        let displayValNormDate = this.props.type === 'time' ? NORM_TIME : NORM_DATE;

        if (this.state.value.timeIntervals != null) {
            let TI = this.state.value.timeIntervals;

            displayValTimeIntervals = TI.timePart;

            if (TI.timePart == null && TI.timeEntity != null) {
                displayValTimeIntervals = TI.timeEntity;
            }
            if (displayValTimeIntervals == null) {
                displayValTimeIntervals = 'none';
            }

            displayValIntervalLength = TI.intervalLength;

            if (TI.normDate != null && TI.normDate != '') {
                displayValNormDate = TI.normDate;
            }

            optionsNum = this.getOptionsNum(displayValTimeIntervals);
        }

        return (
            <div>
                <span style={styleDescr}>
                    {
                        'Time intervals can be used to group results in intervals.\
                        As example if you want to count the number of results in intervals of 3 months length \
                        you select Month with an interval length of 3, and you see the count in three months \
                        intervals.By Using a NormDate, you can set the Base for the Intervals. \
                        As example for the 3 months intervals you can set what should be the first month.'
                    }
                </span>

                <div className="values-container-flex">
                    <div className="values-flex-first">
                        <label>
                            <span>Time Part: </span>
                        </label>
                        <select
                            ref={(input) => {
                                this.references.timeEntityCtrl = input;
                            }}
                            value={displayValTimeIntervals}
                            className="form-control"
                            onChange={this.timeEntityChange}
                        >
                            {optionsTimeInterval}
                        </select>
                    </div>

                    <div className="values-flex">
                        <label>
                            <span>Interval Length: </span>
                        </label>
                        <select
                            ref={(input) => {
                                this.references.intervalLengthCtrl = input;
                            }}
                            value={displayValIntervalLength}
                            className="form-control"
                            onChange={this.timeIntervalChange}
                        >
                            {optionsNum}
                        </select>
                    </div>

                    <div className="values-flex norm-date">
                        <label title={normTimeTitle}>
                            <span>{normDateText} </span>
                        </label>
                        <StringField
                            value={displayValNormDate}
                            changeOnBlurOnly={true}
                            applyOnEnter={true}
                            onChange={this.normDateChange}
                        />
                    </div>
                </div>

                <div className="dateError">{errors.join(', ')}</div>
            </div>
        );
    }
}

class NumericRegularInterval extends React.Component<any, any> {
    constructor(props) {
        super(props);

        let valueOrig = this.props.value || {};
        let errors = validateRegularIntervals(valueOrig, this.props.type);
        this.state = { value: valueOrig, hasIntervalError: errors.length > 0 };
    }

    intervalLengthChange = (value) => {
        let obj = this.state.value;
        let val = 0;
        let hasIntervalError = false;

        if (this.props.type === 'r') {
            val = parseFloat(value);
        } else {
            val = parseInt(value);
        }

        if (isNaN(val) || val == null) {
            val = 0;
        }

        if (val < 0) {
            hasIntervalError = true;
        }

        if (val === 0) {
            delete obj.numberIntervals;
        } else if (obj.numberIntervals == null) {
            obj.numberIntervals = { intervalLength: val, normValue: 0 };
        } else {
            obj.numberIntervals.intervalLength = val;
        }

        this.handlePeriodicInterval_ValueChange(obj, hasIntervalError);
    };

    normValueChange = (value) => {
        let obj = this.state.value;
        let val = 0;

        if (this.props.type === 'r') {
            val = parseFloat(value);
        } else {
            val = parseInt(value);
        }

        let hasIntervalError = false;

        if (isNaN(val) || val == null) {
            val = 0;
        }
        if (obj.numberIntervals == null) {
            obj.numberIntervals = { normValue: val, intervalLength: 0 };
        } else {
            obj.numberIntervals.normValue = val;
        }

        if (obj.numberIntervals != null) {
            if (obj.numberIntervals.intervalLength == 0 && obj.numberIntervals.normValue == 0) {
                delete obj.numberIntervals;
            } else if (obj.numberIntervals.intervalLength == 0) {
                hasIntervalError = true;
            }
        }

        this.handlePeriodicInterval_ValueChange(obj, hasIntervalError);
    };

    handlePeriodicInterval_ValueChange = (value, hasIntervalError) => {
        this.setState({
            value: value,
            hasIntervalError: hasIntervalError
        });
        //VR: even null should be passed to parent: if (value.numberIntervals != null)
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, hasIntervalError);
        }
    };

    render() {
        let displayNormValue = 0;
        let displayintervalLength = 0;

        // set values:
        if (this.state.value.numberIntervals != null) {
            displayNormValue = this.state.value.numberIntervals.normValue;
            displayintervalLength = this.state.value.numberIntervals.intervalLength;
        }
        let errors = validateRegularIntervals(this.state.value, this.props.type);

        return (
            <div className="periodic-interval">
                <div>
                    <span style={styleDescr}>
                        {
                            'Regular Intervals can be used to group numeric values into intervals with a fixed length. \
                        As example if you want to count population with different ages, \
                        you can select to group the age into intervals of ex. 10 year length, \
                        and then do a count for the population in each interval. \
                        ‘Norm Value’ is a value to specify the start of the intervals. \
                        The numeric values returned will be the middle of the intervals. \
                        Setting ‘Interval Length’ back to zero disables intervals.'
                        }
                    </span>

                    <div className="values-container-flex">
                        <div className="values-flex-first">
                            <label>
                                <span>Interval Length: </span>
                            </label>
                            <NumberField
                                value={displayintervalLength}
                                onChange={this.intervalLengthChange}
                                applyOnEnter={true}
                            />
                        </div>
                        <div className="values-flex">
                            <label>
                                <span>Norm Value: </span>
                            </label>
                            <NumberField value={displayNormValue} onChange={this.normValueChange} applyOnEnter={true} />
                        </div>
                    </div>
                </div>

                <div className="dateError">{errors.join(', ')}</div>
            </div>
        );
    }
}

interface IIntervalSelectPopupOptions extends IPopupOptions {
    value;
    type: string;
    notUseRegularTab: boolean;
    themeObj?: IValuesCollection;
    withMappings: boolean;
    mapping?: IMappingValue_Internal;
    targetTypes?: number[];
    imageMappingMode?: ImageMappingModeType;

    hideBackendTab: boolean;
    allowFrontendAttributeMapping: boolean;
    isCountAggregate: boolean;

    onChange(value): void;
}

interface IIntervalSelectPopupState {
    value: IIntervals;
    mode?;
    upperMode?;
    dataTypeCalc;
    useIntervalType_InitialCalc?: boolean;
    upperMappingsMode?;
    curMappingType?: MappingType; //LL: 09.04.20: + 'AttributeMapping'
    //LL: must have 2 saved mappings, for each mappingType (if later will be > 2, an object mappings):
    mappings?: any; // object for each MappingType as IMappingValue_Internal  //LL: 09.04.20: + 'AttributeMapping'
    imageMappingMode?: ImageMappingModeType;
    revert?: boolean;
    hasIntervalError?;
    height?: number;
    width?: number;
}

export class IntervalSelectPopup extends React.Component<
    {
        zIndex: number;
        options: IIntervalSelectPopupOptions;
        glob: IGlob;
        close(): void;
    },
    IIntervalSelectPopupState
> {
    private internalConst = {
        tabUserDefinedIntervals: 'intervalsTab',
        tabTimePart: 'timePartTab',
        tabTimePeriod: 'timePeriodTab',
        tabRegularIntervals_Time: 'timeIntervalTab',
        tabRegularIntervals_Numeric: 'integerPeriodicIntervalTab',
        unknown: 'unknown',
        none: 'none'
    };

    private internalConstUpperMode = {
        tabUpperIntervals: 'intervalsUpperTab',
        tabUpperTimePart: 'timePartUpperTab'
    };

    private internalConstUpperMappingsMode = {
        tabUpperMappingsBackend: 'backendUpperMappingsTab',
        tabUpperMappingsFrontend: 'frontendUpperMappingsTab'
    };

    // see export type MappingType = 'DiscreteMapping' | 'ColorScale' | 'AttributeMapping' | 'none';
    private references: {
        popoverContent?: HTMLElement;
        periodPointCtrl?: HTMLElement;
        selectMapping_DiscreteMapping?: HTMLElement;
        selectMapping_ColorScale?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        const valueOrig = $.extend(true, {}, this.props.options.value);

        let hasError = false;
        let errors = validateWhole(valueOrig, this.props.options.type);

        if (errors.length > 0) {
            hasError = true;
        }

        const dataTypeCalc = this.getCalculatedDataType(this.props.options.type, valueOrig);
        const mappingOrig: IMappingValue_Internal =
            this.props.options.mapping != null ? $.extend(true, {}, this.props.options.mapping) : null;

        let curMappingType: MappingType = 'DiscreteMapping'; // type MappingType = 'DiscreteMapping' | 'ColorScale' //LL: 09.04.20: + 'AttributeMapping'

        if (mappingOrig != null) {
            curMappingType = mappingOrig.mappingType;
        }

        let mappings = {}; // object for each MappingType

        mappings[curMappingType] = mappingOrig; // may be null

        if (this.props.options.allowFrontendAttributeMapping) {
            //LL: always add for 'AttributeMapping':
            if (curMappingType != 'AttributeMapping') {
                mappings['AttributeMapping'] = {
                    mappingType: 'AttributeMapping',
                    mappingName: 'AttributeMapping',
                    mappingObj: {}
                };
            }
        }

        let upperMappingsMode =
            this.props.options.hideBackendTab !== true
                ? this.internalConstUpperMappingsMode.tabUpperMappingsBackend
                : this.internalConstUpperMappingsMode.tabUpperMappingsFrontend;

        //LL: 14.04.20: introduce new useIntervalType = useNone, will be shown if no intervals are defined
        //LL: 14.04.20: state.useIntervalType_InitialCalc:
        //       Used to show as initial new "useNone" radio-choice, when no intervals are defined
        //       Set here, if valueOrig.useIntervalType is not set to "useNone" explicitly
        //       Will be dropped (or set false), when useIntervalType is changed
        let myMode = this.evalInternalMode(valueOrig, true);
        let useIntervalType_InitialCalc; //LL  is set when not useNone, switch off when useIntervalType is changed
        //if (valueOrig.useIntervalType != null && valueOrig.useIntervalType !== useDateTimeIntervalType.useNone) {
        if (valueOrig.useIntervalType == null || valueOrig.useIntervalType !== useDateTimeIntervalType.useNone) {
            useIntervalType_InitialCalc = true;
            let useIntervalType = this.eval_useIntervalType(valueOrig, true);
            valueOrig.useIntervalType = useIntervalType;
        }

        const newState: IIntervalSelectPopupState = {
            value: valueOrig,
            dataTypeCalc: dataTypeCalc,
            //mode: this.internalConst.unknown,
            mode: myMode, //LL: 13.04.20   not used ???
            hasIntervalError: hasError, //false,
            upperMode: this.evalUpperMode(valueOrig),

            upperMappingsMode: upperMappingsMode,
            curMappingType: curMappingType, // type MappingType = 'DiscreteMapping' | 'ColorScale' //LL: 09.04.20: + 'AttributeMapping'
            mappings: mappings,

            imageMappingMode: this.props.options.imageMappingMode,

            height: 500, //LL: Reset in DidMount
            width: 530 //LL: Reset in DidMount
        };

        if (useIntervalType_InitialCalc != null) {
            newState.useIntervalType_InitialCalc = useIntervalType_InitialCalc;
        }

        this.state = newState;
    }

    componentDidMount() {
        const dialog = this.references.popoverContent;
        // VR: needed for JEST testing: "if(dialog != null)"
        if (dialog != null) {
            this.setState(
                _.extend(this.state, {
                    height: dialog.clientHeight,
                    width: dialog.clientWidth
                })
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // You may call setState() immediately in componentDidUpdate() but note that it must be wrapped in a condition
        if (this.state.revert === true) {
            this.setState({ revert: false });
        }
    }

    evalUpperMode = (value) => {
        // Used this.props.options.type
        //LL:  value is this.state.value or this.props.options.value
        let isTimePartDefined = hasTimePartFunc(value, this.props.options.type);
        let isIntervalsDefined = false;
        let using = evalUsingIntervals(value, this.props.options.type);

        if (using.useRegular) {
            isIntervalsDefined = using.hasRegular;
        } else if (using.useUserDefined) {
            isIntervalsDefined = using.hasUserDefined;
        } else if (using.useTimePeriods) {
            isIntervalsDefined = using.hasTimePeriods;
        }

        let myUpperMode = this.evalUpperMode_conditional(isTimePartDefined, isIntervalsDefined);

        return myUpperMode;
    };

    evalUpperMode_conditional = (isTimePartDefined, isIntervalsDefined) => {
        let myUpperMode: string;

        if (isTypeOfAnyDate(this.props.options.type)) {
            myUpperMode = this.internalConstUpperMode.tabUpperTimePart;
        } else {
            myUpperMode = this.internalConstUpperMode.tabUpperIntervals; // no TimeParts when not Date
        }
        //LL: open on TimeParts if current Interval is not defined:
        if (myUpperMode === this.internalConstUpperMode.tabUpperIntervals) {
            if (!isIntervalsDefined && isTimePartDefined) {
                myUpperMode = this.internalConstUpperMode.tabUpperTimePart;
            }
        }
        //LL: open on Intervals if TimeParts is not defined:
        else if (myUpperMode === this.internalConstUpperMode.tabUpperTimePart) {
            if (isIntervalsDefined && !isTimePartDefined) {
                myUpperMode = this.internalConstUpperMode.tabUpperIntervals;
            }
        }

        return myUpperMode;
    };

    normalize = (value) => {
        //LL: 01.04.18:  useRegularIntervals is outdated, now useIntervalType
        if (value.useRegularIntervals != null) {
            if (value.useIntervalType == null) {
                if (value.useRegularIntervals) {
                    value.useIntervalType = useDateTimeIntervalType.useRegular;
                } else {
                    value.useIntervalType = useDateTimeIntervalType.useNone;
                }
            }
            //delete value.useRegularIntervals;  //LL: don't delete for a while - to use old functionality
        }

        if (value.timeIntervals != null && value.timeIntervals.periodPoint != null) {
            delete value.timeIntervals.periodPoint;
        }
        if (value.numberIntervals != null && value.numberIntervals.periodPoint != null) {
            delete value.numberIntervals.periodPoint;
        }

        if (value.timePeriods != null) {
            if (value.timePeriods.periodPoint != null) {
                delete value.timePeriods.periodPoint;
            }

            if (value.timePeriods.timePeriodPoint != null) {
                delete value.timePeriods.timePeriodPoint;
            }
        }

        if (value.timePeriods != null) {
            if (value.timePeriods.timePeriodTimeZoneAnother !== true) {
                delete value.timePeriods.timePeriodTimeZone;
            }
        }
    };

    handleOnChange = (value: IIntervals, hasIntervalError?: boolean, useIntervalTypeChanged?: boolean) => {
        this.normalize(value);

        const dataTypeCalc = this.getCalculatedDataType(this.props.options.type, value);
        const dataTypeCalc_prev = this.state.dataTypeCalc;
        const isFrontendDefined = this.isFrontendMappingDefined();

        if (isFrontendDefined) {
            if (dataTypeCalc !== dataTypeCalc_prev) {
                if (!areCompatibleDataTypes(dataTypeCalc_prev, dataTypeCalc, false)) {
                    this.props.glob.DialogActions.createDialogConfirm(
                        'Data Type will be changed',
                        'Calculated Data Type is to be changed, though Mapping is selected. Mapping will be cleared.',
                        () => {
                            //   OK => Mapping will be cleared
                            let newMappings: any;

                            newMappings = $.extend(true, {}, this.state.mappings);

                            let curMappingType = this.state.curMappingType;

                            delete newMappings[curMappingType];

                            const newState: IIntervalSelectPopupState = {
                                mappings: newMappings,
                                value: value,
                                dataTypeCalc: dataTypeCalc
                            };

                            if (hasIntervalError != null) {
                                newState.hasIntervalError = hasIntervalError;
                            }
                            //LL: 14.04.20: add useIntervalTypeChanged (to set off in state useIntervalType_InitialCalc)
                            if (useIntervalTypeChanged === true) {
                                newState.useIntervalType_InitialCalc = false; //null;
                            }

                            this.setState(newState);
                        },
                        () => {}, //LL: regulated by cancelTitle, but by default is "Deny"
                        () => {
                            //LL: regulated by closeTitle, but by default is "Cancel"
                            //LL:   Cancel => revert to prev state
                            this.setState({
                                revert: true //,  //LL: 18.12.19   and unset in componentDidUpdate
                                //dataTypeCalc: dataTypeCalc  //LL: 20.12.19
                            });
                        },
                        {
                            confirmTitle: 'OK',
                            cancelTitle: null //LL:  don't show Deny
                        }
                    );
                }
            }
        }

        const newState: IIntervalSelectPopupState = {
            value: value,
            dataTypeCalc: dataTypeCalc,
            hasIntervalError: hasIntervalError
        };
        //if (newMappings != null) {
        //    st.mappings = newMappings;
        //}

        //LL: 14.04.20: add useIntervalTypeChanged (to set off in state useIntervalType_InitialCalc)
        if (useIntervalTypeChanged === true) {
            newState.useIntervalType_InitialCalc = false; //null;
        }

        this.setState(newState);
        //LL:  was before including Mappings:  ===================
        // if (typeof this.props.options.onChange === 'function') {
        //     this.props.options.onChange(value);
        // }
    };

    handleMappingChange = (mappingType: MappingType, mapping, hasIntervalError?) => {
        //this.normalize(value);
        let mappings = $.extend(true, {}, this.state.mappings);

        mappings[mappingType] = mapping; // may be null
        this.setState({
            mappings: mappings,
            hasIntervalError: hasIntervalError
        });
    };

    containerClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    validateMapping = (value, type) => {
        let error: string;

        if (this.props.options.withMappings) {
            const dataTypeCalc = this.getCalculatedDataType(type, value);
            const isFrontendDefined = this.isFrontendMappingDefined();

            if (isFrontendDefined) {
                if (this.state.curMappingType != 'AttributeMapping') {
                    const mapping: IMappingValue_Internal = this.state.mappings[this.state.curMappingType];

                    if (mapping != null) {
                        //LL: actually checked in isFrontendMappingDefined
                        const mapObj = mapping.mappingObj;
                        const isDiscrete = mapping.mappingType === 'DiscreteMapping' || mapObj.mapping === 'discrete';
                        const isCompatible = isCompatibleMapping(isDiscrete, mapObj.dataType, dataTypeCalc);

                        if (!isCompatible) {
                            error = 'Calculated Data Type is not compatible with Data Type of after-Mapping';
                        }
                    }
                }
            }
        }

        return error;
    };

    closeButtonHandler = () => {
        let hasError = this.state.hasIntervalError;

        if (hasError != true) {
            let errors = validateWhole(this.state.value, this.props.options.type);
            let mappError = this.validateMapping(this.state.value, this.props.options.type);

            if (mappError != null) {
                errors.push(mappError);
            }

            if (errors.length > 0) {
                hasError = true;
            }
        }

        if (hasError) {
            this.props.glob.AppActions.showNotification_Warning(
                'Configuration is not valid. Some fields have wrong value'
            );
        } else {
            if (typeof this.props.options.onChange === 'function') {
                let withMappings = this.props.options.withMappings;

                if (withMappings === true) {
                    // new
                    let mapping = this.state.mappings[this.state.curMappingType];
                    //this.props.options.onChange({ intervals: this.state.value, mapping: mapping });
                    let imageMappingMode = this.state.imageMappingMode;

                    this.props.options.onChange({
                        intervals: this.state.value,
                        mapping: mapping,
                        imageMappingMode: imageMappingMode
                    });
                } else {
                    // old
                    this.props.options.onChange(this.state.value);
                }
            }

            this.props.close();
        }
    };

    escapeButtonHandler = () => {
        // if (typeof this.props.options.onChange === 'function') {
        //     this.props.options.onChange(this.state.valueOrig);
        // }
        this.props.close();
    };

    getUpperTabClick = (upperMode) => {
        return (e) => {
            this.setState({ upperMode: upperMode });
            e.preventDefault();
        };
    };

    processUseRadioTabChange = (val) => {
        let obj = _.clone(this.state.value || {});

        obj.useIntervalType = val;
        this.handleOnChange(obj, null, true);
    };

    getUpperTab = (dataType, upperMode, text, isDefined, isDefined_butNotUsed, curUpperMode) => {
        //LL: only for Dates
        let className = 'nav-link';

        if (isTypeOfAnyDate(dataType)) {
            switch (upperMode) {
                case this.internalConstUpperMode.tabUpperIntervals:
                    className += curUpperMode === upperMode ? ' active' : '';
                    break;
                case this.internalConstUpperMode.tabUpperTimePart:
                    className += curUpperMode === upperMode || curUpperMode == null ? ' active' : '';
                    break;
            }
        } else {
            return null;
        }

        let starElem;

        if (isDefined === true || isDefined_butNotUsed === true) {
            const styleStar: React.CSSProperties = {
                marginRight: '5px',
                fontSize: 'x-small',
                cursor: 'default'
            };

            if (isDefined !== true) {
                styleStar.color = '#cccccc';
            }
            let titleStar = isDefined === true ? 'defined' : 'defined, not used';

            //LL: or glyphicon-star
            starElem = <span style={styleStar} className="glyphicon glyphicon-asterisk" title={titleStar}></span>;
        }

        return (
            <li
                role="timeInterolPresent"
                className="nav-item"
                style={{
                    width: '50%',
                    textAlign: 'center'
                }}
            >
                <a href="#" className={className} onClick={this.getUpperTabClick(upperMode)}>
                    {starElem}
                    {text}
                </a>
            </li>
        );
    };

    getUpperMappingsTabClick = (upperMappingsMode) => {
        return (e) => {
            this.setState({ upperMappingsMode: upperMappingsMode });
            e.preventDefault();
        };
    };

    getUpperMappingsTab = (
        dataType,
        upperMappingsMode,
        text,
        isDefined,
        isDefined_butNotUsed,
        curUpperMappingsMode
    ) => {
        let className = 'nav-link';

        //   Backend is default      hideBackendTab: boolean; //LL: 12.12.19
        switch (upperMappingsMode) {
            case this.internalConstUpperMappingsMode.tabUpperMappingsFrontend:
                className += curUpperMappingsMode === upperMappingsMode ? ' active' : '';
                break;
            case this.internalConstUpperMappingsMode.tabUpperMappingsBackend:
                className +=
                    curUpperMappingsMode === upperMappingsMode || curUpperMappingsMode == null ? ' active' : '';
                break;
        }

        let W = '50%';
        if (this.props.options.hideBackendTab === true) {
            W = '100%'; // only 1 Tab
        }

        let style1: React.CSSProperties = {
            width: W,
            textAlign: 'center'
        };

        let starElem;

        if (isDefined === true || isDefined_butNotUsed === true) {
            const styleStar: React.CSSProperties = {
                marginRight: '5px',
                fontSize: 'x-small',
                cursor: 'default'
            };

            if (isDefined !== true) {
                styleStar.color = '#cccccc';
            }

            let titleStar = isDefined === true ? 'defined' : 'defined, not used';

            //LL: or glyphicon-star
            starElem = <span style={styleStar} className="glyphicon glyphicon-asterisk" title={titleStar}></span>;
        }

        return (
            <li role="timeInterolPresent" className="nav-item" style={style1}>
                <a href="#" className={className} onClick={this.getUpperMappingsTabClick(upperMappingsMode)}>
                    {starElem}
                    {text}
                </a>
            </li>
        );
    };

    getCalculatedDataType = (dataType, curValueIntervals) => {
        let dataTypeCalc = dataType;
        //let curValue = this.props.options.value;
        ////LL: state may be undef - in constructor
        //if (this.state != null) {
        //    curValue = this.state.value;
        //}
        let curValue = curValueIntervals;

        if (curValue != null) {
            if (curValue.timePart != null && curValue.timePart != 'none') {
                // only for Dates
                if (isTypeOfAnyDate(dataType)) {
                    dataTypeCalc = 'i';
                }
            } else {
                let using = evalUsingIntervals(curValue, dataType);
                //let useRegular = using.useRegular;
                let useUserDefined = using.useUserDefined;
                //let useTimePeriods = using.useTimePeriods;

                //LL: useRegular and useTimePeriods don't change Type
                if (useUserDefined) {
                    dataTypeCalc = 's';
                }
            }
        }

        return dataTypeCalc;
    };

    isBackendMappingTypeChange = (dataType, curValueIntervals) => {
        let res = false;

        if (curValueIntervals != null) {
            if (curValueIntervals.timePart != null && curValueIntervals.timePart != 'none') {
                // only for Dates
                if (isTypeOfAnyDate(dataType)) {
                    res = true;
                }
            } else {
                let using = evalUsingIntervals(curValueIntervals, dataType);
                //let useRegular = using.useRegular;
                let useUserDefined = using.useUserDefined;
                //let useTimePeriods = using.useTimePeriods;

                //LL: useRegular and useTimePeriods don't change Type
                if (useUserDefined) {
                    res = true;
                }
            }
        }

        return res;
    };

    //LL: 09.04.20: 'AttributeMapping' ?  NO, it is for selecting actual mapping obj
    processMappingChange = (mappingType: MappingType) => {
        // type MappingType = 'DiscreteMapping' | 'ColorScale';
        let self = this;
        return function (e) {
            let elem: any = self.references['selectMapping_' + mappingType];
            let val = elem == null ? null : elem.value;

            if (val === '') {
                //  not_set
                val = null;
            }

            let valObj: IMappingValue_Internal = null;

            if (val != null) {
                let mapObj = null;
                let mapList = getMappingList(self.props.options.themeObj, mappingType);

                if (mapList != null) {
                    mapObj = _.find(mapList, function (m) {
                        return m.name === val;
                    });
                    if (mapObj != null) {
                        mapObj = $.extend(true, {}, mapObj);
                    }
                }
                valObj = {
                    mappingType: mappingType,
                    mappingName: val,
                    mappingObj: mapObj
                };
            }

            self.handleMappingChange(mappingType, valObj); //LL: save in state
        };
    };

    //LL: 09.04.20: 'AttributeMapping' ?  NO, it is for selecting actual mapping obj
    createMappingListElement = (mappingType: MappingType, dataTypeCalc: string, disabled: boolean) => {
        // type MappingType = 'DiscreteMapping' | 'ColorScale';
        let result: React.JSX.Element = null;

        if (this.props.options.themeObj == null) {
            result = null;
        } else {
            const mapList = getMappingList(this.props.options.themeObj, mappingType);

            let options: React.JSX.Element[] = [];

            if (mapList != null && mapList.length > 0) {
                //LL: must be only of the compatible data type !! - for DiscreteMapping and of "discrete" type for "ColorScale"
                const mapListReduced = _.filter(mapList, (mapObj) => {
                    const isDiscrete = mappingType === 'DiscreteMapping' || mapObj.mapping === 'discrete';

                    let targetTypes: number[];

                    if (mappingType === 'DiscreteMapping') {
                        targetTypes = this.props.options.targetTypes; // array of DiscreteIntervalsKind (enum from DiscreteIntervals) or null for any
                    }

                    return isCompatibleMapping(
                        isDiscrete,
                        mapObj.dataType,
                        dataTypeCalc,
                        targetTypes,
                        mapObj.resultingType
                    ); //  not self.props.options.type);
                });

                if (mapListReduced != null && mapListReduced.length > 0) {
                    options = _.map(mapListReduced, (item) => {
                        return (
                            <option key={item.name} value={item.name}>
                                {item.name}
                            </option>
                        );
                    });
                }
            }

            // Warning: `value` prop on `select` should not be null.
            // Consider using an empty string to clear the component or `undefined` for uncontrolled components.
            let valObj: IMappingValue_Internal = this.state.mappings[mappingType];
            let mapVal = valObj != null && valObj.mappingName != null ? valObj.mappingName : '';

            //   { "&ltnot_set&gt" }
            options.unshift(
                <option key={' '} value={''}>
                    {'<not_set>'}
                </option>
            );

            let selectMappingElem = (
                <select
                    ref={(input) => {
                        this.references['selectMapping_' + mappingType] = input;
                    }}
                    className="form-control"
                    onChange={this.processMappingChange(mappingType)}
                    value={mapVal}
                    disabled={disabled}
                >
                    {options}
                </select>
            );

            result = (
                <div className="select-mapping" title="Select Mapping">
                    {selectMappingElem}
                </div>
            );
        }

        return result;
    };

    getDiscreteMappingContent(dataTypeCalc, disabled: boolean) {
        let c = this.createMappingListElement('DiscreteMapping', dataTypeCalc, disabled);

        return <div className="discrete-mapping-content">{c}</div>;
    }

    getColorScaleContent(dataTypeCalc, disabled: boolean) {
        let c = this.createMappingListElement('ColorScale', dataTypeCalc, disabled);

        return <div className="color-scale-content">{c}</div>;
    }

    getAttributeMappingContent(dataTypeCalc, disabled, prohibitAttributeMapping, isCountAggregate) {
        let c = null;
        let msgBackendMapping;

        if (prohibitAttributeMapping) {
            msgBackendMapping = <p>{'Backend Mapping changes initial Data Type, Attribute Mapping disabled'}</p>;
        }

        let msgCountAggregate;

        if (isCountAggregate) {
            msgCountAggregate = <p>{'"count" Aggregation is used, Attribute Mapping disabled'}</p>;
        }

        c = (
            <div>
                {msgBackendMapping}
                {msgCountAggregate}
            </div>
        );

        return <div className="color-scale-content">{c}</div>;
    }

    processMappingTypeChange = (val) => {
        this.setState({ curMappingType: val });
    };

    handleOnImageMappingModeChange = (val) => {
        this.setState({ imageMappingMode: val });
    };

    getFrontendElement = (dataType, dataTypeCalc, isBackendMappingTypeChange) => {
        let dataTypeElem = (
            <p>
                Source Data Type: <strong>{explainAttributeType(dataType)}</strong>
            </p>
        );
        let dataTypeCalcElem = (
            <p>
                Source Calculated Data Type: <strong>{explainAttributeType(dataTypeCalc)}</strong>
            </p>
        );

        const rgItems: IRadioGroupFieldItem[] = [];
        const curMappingType = this.state.curMappingType;
        const disabledDiscreteMappingContent = curMappingType !== 'DiscreteMapping';
        const disabledColorScaleContent = curMappingType !== 'ColorScale';
        const disabledAttributeMappingContent = curMappingType !== 'AttributeMapping';

        // - 'DiscreteMapping':
        //   item.content;  //LL:  null or react element
        rgItems.push({
            text: 'Discrete Mappings',
            value: 'DiscreteMapping',
            content: this.getDiscreteMappingContent(dataTypeCalc, disabledDiscreteMappingContent)
        });

        // - 'ColorScale':
        let disabledColorScale = false;
        let targetTypes = this.props.options.targetTypes; // array of DiscreteIntervalsKind (enum from DiscreteIntervals) or null for any

        if (targetTypes != null) {
            const colorKind = _.find(targetTypes, function (m) {
                return m === DiscreteIntervalsKind.color;
            });

            if (colorKind == null) {
                disabledColorScale = true;
            }
        }

        let contentColorScale = null;

        if (disabledColorScale === false) {
            contentColorScale = this.getColorScaleContent(dataTypeCalc, disabledColorScaleContent);
        }

        rgItems.push({
            text: 'Color Scales',
            value: 'ColorScale',
            content: contentColorScale,
            disabled: disabledColorScale
        });

        if (this.props.options.allowFrontendAttributeMapping) {
            //LL: 10.04.20
            //LL: disable if Backend Mapping exists, also depending on aggregation
            //LL: 30.10.20: also disable by disabledColorScale
            const prohibitAttributeMapping = isBackendMappingTypeChange;
            const isCountAggregate = this.props.options.isCountAggregate;
            const disabledAttributeMapping = prohibitAttributeMapping || isCountAggregate || disabledColorScale;

            let contentAttrMapping = null;

            if (disabledColorScale === false) {
                contentAttrMapping = this.getAttributeMappingContent(
                    dataTypeCalc,
                    disabledAttributeMappingContent,
                    prohibitAttributeMapping,
                    isCountAggregate
                );
            }

            rgItems.push({
                text: 'Attribute Mapping',
                value: 'AttributeMapping',
                content: contentAttrMapping,
                disabled: disabledAttributeMapping
            });
        }

        //LL: 25.01.21: was in AttributeOptionsSelect.tsx for DataEdit Widget
        let imageMappingModeElem;

        if (curMappingType === 'DiscreteMapping') {
            let resultingType;
            let dMapp = this.state.mappings.DiscreteMapping;

            if (dMapp != null && dMapp.mappingObj != null) {
                resultingType = dMapp.mappingObj.resultingType;
            }

            if (resultingType === DiscreteIntervalsKind.icon) {
                //LL: was in AttributeOptionsSelect.tsx for DataEdit Widget
                const optionsRG = {
                    layout: 'vertical',
                    name: 'RG_imageMapping',
                    items: [
                        {
                            text: 'Draw Image near to Value (Image + Value)',
                            value: 'imageValue'
                        },
                        {
                            text: 'Replace Value (only Image)',
                            value: 'onlyImage'
                        }
                    ]
                };

                let imageMappingMode = this.state.imageMappingMode;

                //LL: margins схлопываются: верхний 10 + этот 15 будет 15
                const styleImageMappingMode: React.CSSProperties = {
                    marginTop: '15px',
                    marginBottom: '10px'
                };

                imageMappingModeElem = (
                    <div style={styleImageMappingMode}>
                        <p>{'What to do with Image Mapping:'}</p>
                        <RadioGroupFieldComponent
                            value={imageMappingMode || 'imageValue'}
                            options={optionsRG}
                            onChange={this.handleOnImageMappingModeChange}
                        />
                    </div>
                );
            }
        }

        return (
            <div className="frontend-content">
                {dataTypeElem}
                {dataTypeCalcElem}

                <div
                    style={{
                        marginTop: '10px',
                        marginBottom: '10px'
                    }}
                >
                    <RadioGroupFieldComponent
                        value={curMappingType}
                        options={{
                            name: 'RG_MappingType', //LL: needed to differ RadioGroup from other RadioGroups
                            layout: 'vertical',
                            items: rgItems
                        }}
                        onChange={this.processMappingTypeChange}
                    />
                </div>

                {imageMappingModeElem}
            </div>
        );
    };

    periodPointChange = (e) => {
        let val = (this.references.periodPointCtrl as HTMLInputElement).value;
        let obj = this.state.value;

        obj.periodPoint = val;
        this.handleOnChange(obj);
    };

    getOptions = (list) => {
        return _.map(list, (obj) => {
            return (
                <option key={obj.type} title={obj.name} value={obj.type}>
                    {obj.type}
                </option>
            );
        });
    };

    getIntervalContent = (internalMode) => {
        let result: React.JSX.Element;

        switch (internalMode) {
            case this.internalConst.tabUserDefinedIntervals:
                result = (
                    <div className="popover-body">
                        <UserDefinedIntervals
                            value={this.state.value}
                            type={this.props.options.type}
                            themeObj={this.props.options.themeObj}
                            glob={this.props.glob}
                            onChange={this.handleOnChange}
                        />
                    </div>
                );
                break;

            case this.internalConst.tabTimePeriod:
                result = (
                    <div className="popover-body">
                        <CalendarPeriods
                            value={this.state.value}
                            type={this.props.options.type}
                            theme={this.props.options.themeObj}
                            glob={this.props.glob}
                            onChange={this.handleOnChange}
                        />
                    </div>
                );
                break;

            case this.internalConst.tabRegularIntervals_Time:
                result = (
                    <div className="popover-body">
                        <DateTimeRegularInterval
                            value={this.state.value}
                            type={this.props.options.type}
                            onChange={this.handleOnChange}
                        />
                    </div>
                );
                break;

            case this.internalConst.tabRegularIntervals_Numeric:
                result = (
                    <div className="popover-body">
                        <NumericRegularInterval
                            value={this.state.value}
                            type={this.props.options.type}
                            onChange={this.handleOnChange}
                        />
                    </div>
                );
                break;

            default:
                //LL: 13.04.20: internalConst.none: 'none'  is here
                result = null;
                break;
        }

        return result;
    };

    eval_useIntervalType = (intervalsValue, isInitial: boolean) => {
        let useIntervalType = useDateTimeIntervalType.useNone;

        if (intervalsValue != null && intervalsValue.useIntervalType != null) {
            useIntervalType = intervalsValue.useIntervalType;
        }

        //LL: initial && intervalsValue.useIntervalType == null  => old versions ??

        if (isInitial === true) {
            let isIntervalsDefined = false;
            let actualUsedIntervalType = useDateTimeIntervalType.useNone;
            let using = evalUsingIntervals(intervalsValue, this.props.options.type);

            if (using.useRegular) {
                isIntervalsDefined = using.hasRegular;
                actualUsedIntervalType = useDateTimeIntervalType.useRegular;
            } else if (using.useUserDefined) {
                isIntervalsDefined = using.hasUserDefined;
                actualUsedIntervalType = useDateTimeIntervalType.useUserDefined;
            } else if (using.useTimePeriods) {
                isIntervalsDefined = using.hasTimePeriods;
                actualUsedIntervalType = useDateTimeIntervalType.useTimePeriods;
            }

            if (!isIntervalsDefined) {
                useIntervalType = useDateTimeIntervalType.useNone;
            }
            //LL: initial && intervalsValue.useIntervalType == null  => old versions ??
            else if (intervalsValue.useIntervalType == null) {
                useIntervalType = actualUsedIntervalType;
            }
        }

        return useIntervalType;
    };

    evalInternalMode = (intervalsValue?, isInitial?) => {
        let myMode;

        //LL: 13.04.20:  state.value old
        if (intervalsValue == null) {
            intervalsValue = this.state.value;
        }

        if (isInitial == null) {
            isInitial = this.state.useIntervalType_InitialCalc;
        }

        let useIntervalType = this.eval_useIntervalType(intervalsValue, isInitial);

        if (isTypeOfAnyDate(this.props.options.type)) {
            myMode = this.internalConst.tabRegularIntervals_Time;

            switch (useIntervalType) {
                case useDateTimeIntervalType.useRegular:
                    myMode = this.internalConst.tabRegularIntervals_Time;
                    break;
                case useDateTimeIntervalType.useUserDefined:
                    myMode = this.internalConst.tabUserDefinedIntervals;
                    break;
                case useDateTimeIntervalType.useTimePeriods:
                    myMode = this.internalConst.tabTimePeriod;
                    break;
                case useDateTimeIntervalType.useNone:
                    myMode = this.internalConst.none;
                    break;
            }
        } else if (
            (this.props.options.type === 'i' || this.props.options.type === 'r') &&
            this.props.options.notUseRegularTab != true
        ) {
            myMode = this.internalConst.tabRegularIntervals_Numeric;

            switch (useIntervalType) {
                case useDateTimeIntervalType.useRegular:
                    myMode = this.internalConst.tabRegularIntervals_Numeric;
                    break;
                case useDateTimeIntervalType.useUserDefined:
                    myMode = this.internalConst.tabUserDefinedIntervals;
                    break;
                case useDateTimeIntervalType.useNone:
                    myMode = this.internalConst.none;
                    break;
            }
        } else {
            myMode = this.internalConst.tabUserDefinedIntervals;
            if (useIntervalType === useDateTimeIntervalType.useNone) {
                myMode = this.internalConst.none;
            }
        }

        return myMode;
    };

    isFrontendMappingDefined() {
        let isFrontendDefined = false;

        if (this.props.options.withMappings === true) {
            if (this.state.curMappingType === 'AttributeMapping') {
                isFrontendDefined = true;
            } else if (this.state.mappings != null && this.state.curMappingType != null) {
                let mapp = this.state.mappings[this.state.curMappingType];

                isFrontendDefined = mapp != null && mapp.mappingObj != null;
            }
        }

        return isFrontendDefined;
    }

    render() {
        const popoverStyle = getPopoverStyle(this.props.options, {
            width: this.state.width,
            height: this.state.height
        });

        let popupTitle = 'Mappings';
        let myMode = this.evalInternalMode();
        let intervalContent = this.getIntervalContent(myMode);

        //LL: for all Intervals/Periods (but not UserDefined),  both Time and Numeric
        let optionsTimePeriodPoint = this.getOptions(TIME_PERIOD_ELEMENTS['timePeriodPoints']);
        let displayValPeriodPoint: any = TIME_PERIOD_ELEMENTS['timePeriodPointDefault'];

        if (displayValPeriodPoint != null) {
            displayValPeriodPoint = displayValPeriodPoint[0].type;
        }

        if (this.state.value != null && this.state.value.periodPoint != null) {
            displayValPeriodPoint = this.state.value.periodPoint;
        }

        let elemPeriodPoint: React.JSX.Element;
        //LL: 13.04.20: internalConst.none: 'none'
        //if (myMode !== this.internalConst.tabUserDefinedIntervals) {
        if (myMode !== this.internalConst.tabUserDefinedIntervals && myMode !== this.internalConst.none) {
            elemPeriodPoint = (
                <div style={{ margin: '15px 15px 15px 0' }}>
                    <label>
                        <span>{'Return point of Interval / Period: '}</span>
                    </label>
                    <select
                        ref={(input) => {
                            this.references.periodPointCtrl = input;
                        }}
                        className="form-control"
                        //value={ displayValPeriodPoint[0].type }
                        value={displayValPeriodPoint}
                        style={{
                            display: 'inline-block',
                            width: '150px',
                            marginLeft: '5px'
                        }}
                        onChange={this.periodPointChange}
                    >
                        {optionsTimePeriodPoint}
                    </select>
                </div>
            );
        }

        //LL: to draw asterisk
        let isTimePartDefined = hasTimePartFunc(this.state.value, this.props.options.type);
        let isIntervalsDefined = false;
        let using = evalUsingIntervals(this.state.value, this.props.options.type);

        if (using.useRegular) {
            isIntervalsDefined = using.hasRegular;
        } else if (using.useUserDefined) {
            isIntervalsDefined = using.hasUserDefined;
        } else if (using.useTimePeriods) {
            isIntervalsDefined = using.hasTimePeriods;
        }

        let isIntervalsDefined_butNotUsed = false;

        if (!isIntervalsDefined) {
            isIntervalsDefined_butNotUsed = using.hasRegular || using.hasUserDefined || using.hasTimePeriods;
        }

        let myUpperMode = this.state.upperMode;

        if (myUpperMode == null) {
            myUpperMode = this.evalUpperMode_conditional(isTimePartDefined, isIntervalsDefined);
        }

        let upperContent;

        switch (myUpperMode) {
            case this.internalConstUpperMode.tabUpperIntervals:
                //LL: dates - 3, numeric - 2, strings - 1 (UserDef), time - 3
                let isDate = isTypeOfDateOrDatetime(this.props.options.type);
                let isTime = isTypeOfTime(this.props.options.type);
                let isNum = this.props.options.type === 'i' || this.props.options.type === 'r';
                let displayUseIntervalType = useDateTimeIntervalType.useNone;

                if (this.state.value != null && this.state.value.useIntervalType != null) {
                    displayUseIntervalType = this.state.value.useIntervalType;
                }

                let rgItems = [];
                rgItems.push({
                    text: 'None',
                    value: useDateTimeIntervalType.useNone
                });

                if (isDate || isNum || isTime) {
                    rgItems.push({
                        text: 'Regular Intervals',
                        value: useDateTimeIntervalType.useRegular
                    });
                }

                rgItems.push({
                    text: 'User Defined Intervals',
                    value: useDateTimeIntervalType.useUserDefined
                });

                if (isDate || isTime) {
                    rgItems.push({
                        text: 'Calendar Periods',
                        value: useDateTimeIntervalType.useTimePeriods
                    });
                }

                //LL: 20.04.20: for layout: "horizontal":
                //      horizontalOverflow?: HorizontalOverflowType;  // 'hidden' | 'wrap' (default)
                let rgOptions: any = {
                    name: 'RG_IntervalType', //LL: needed to differ RadioGroup from other RadioGroups
                    layout: 'horizontal',
                    horizontalOverflow: 'hidden',
                    items: rgItems
                };
                //LL: 18.12.19:  RadioGroup is Uncontrolled Component, defaultChecked={ checked } is used
                let initRG = this.state.revert === true;

                if (initRG) {
                    rgOptions.useInitialValue = true;
                }

                let styleDefineIntervals: any = { borderTop: '1px solid gray' };
                let labelText = 'Define Intervals:';

                if (displayUseIntervalType === useDateTimeIntervalType.useTimePeriods) {
                    labelText = 'Define Period:';
                }

                if (displayUseIntervalType === useDateTimeIntervalType.useNone) {
                    styleDefineIntervals = {};
                    labelText = '';
                }

                upperContent = (
                    <div className="popover-body">
                        <div
                            style={{
                                marginTop: '15px',
                                marginBottom: '20px'
                            }}
                        >
                            <ParameterField title={'Choose Interval Type to use '}>
                                <RadioGroupFieldComponent
                                    value={displayUseIntervalType}
                                    options={rgOptions}
                                    onChange={this.processUseRadioTabChange}
                                />
                            </ParameterField>
                        </div>

                        {elemPeriodPoint}

                        <label>{labelText}</label>
                        <div style={styleDefineIntervals}>
                            <div className="tab-content">
                                <div className="tab-pane active">{intervalContent}</div>
                            </div>
                        </div>
                    </div>
                );
                break;

            case this.internalConstUpperMode.tabUpperTimePart:
                upperContent = (
                    <div className="popover-body">
                        <TimeParts
                            value={this.state.value}
                            type={this.props.options.type}
                            theme={this.props.options.themeObj}
                            onChange={this.handleOnChange}
                        />
                    </div>
                );
                break;
        }

        //LL: change Tab order: TimeParts first (Leo's request)
        let separateElem = (
            <div className="separate-upper-tab">
                <ul className="nav nav-tabs">
                    {this.getUpperTab(
                        this.props.options.type,
                        this.internalConstUpperMode.tabUpperTimePart,
                        'Time Parts',
                        isTimePartDefined,
                        false,
                        myUpperMode
                    )}
                    {this.getUpperTab(
                        this.props.options.type,
                        this.internalConstUpperMode.tabUpperIntervals,
                        'Intervals',
                        isIntervalsDefined,
                        isIntervalsDefined_butNotUsed,
                        myUpperMode
                    )}
                </ul>
                <div className="tab-content">
                    <div className="tab-pane active">{upperContent}</div>
                </div>
            </div>
        );

        let errors = validateWhole(this.state.value, this.props.options.type);
        let mappError = this.validateMapping(this.state.value, this.props.options.type);

        if (mappError != null) {
            errors.push(mappError);
        }

        let errorsElem = <div style={{ color: 'red', margin: '10px' }}>{errors.join(', ')}</div>;

        //LL:  separateElem inside, errorsElem outside ----------------
        //LL: names by Leo:
        //LL: <em> (italic),  also <mark> (yellow back), <strong> (bold)
        //const backendText = "Mapping <em>before</em> aggregation and other functions";
        //const frontendText = "Mapping <strong>after</strong> aggregation and other functions";
        const backendText = (
            <span>
                {'Mapping '}
                <em>{'before'}</em>
                {' aggregation and other functions'}
            </span>
        );
        const frontendText = (
            <span>
                {'Mapping '}
                <em>{'after'}</em>
                {' aggregation and other functions'}
            </span>
        );

        let myUpperMappingsMode = this.state.upperMappingsMode;
        if (myUpperMappingsMode == null) {
            myUpperMappingsMode =
                this.props.options.hideBackendTab !== true
                    ? this.internalConstUpperMappingsMode.tabUpperMappingsBackend
                    : this.internalConstUpperMappingsMode.tabUpperMappingsFrontend;
        }

        let isBackendDefined = false; //LL: not used for now
        let isBackendDefined_butNotUsed = false; //LL: not used for now
        let isFrontendDefined_butNotUsed = false; //LL: not used for now
        const isFrontendDefined = this.isFrontendMappingDefined();

        let upperMappingsContent;

        switch (myUpperMappingsMode) {
            case this.internalConstUpperMappingsMode.tabUpperMappingsBackend:
                upperMappingsContent = separateElem;
                break;

            case this.internalConstUpperMappingsMode.tabUpperMappingsFrontend:
                let dataTypeCalc = this.getCalculatedDataType(this.props.options.type, this.state.value);
                let isBackendMappingTypeChange = this.isBackendMappingTypeChange(
                    this.props.options.type,
                    this.state.value
                );
                // aggregation ?
                upperMappingsContent = this.getFrontendElement(
                    this.props.options.type,
                    dataTypeCalc,
                    isBackendMappingTypeChange
                );
                break;
        }

        let backendUpperMappingsTabElem = null;
        if (this.props.options.hideBackendTab !== true) {
            backendUpperMappingsTabElem = this.getUpperMappingsTab(
                this.props.options.type,
                this.internalConstUpperMappingsMode.tabUpperMappingsBackend,
                backendText,
                isBackendDefined,
                isBackendDefined_butNotUsed,
                myUpperMappingsMode
            );
        }

        //LL: 27.04.20:  was <ul className="nav nav-pills">,
        //       try vertical <ul className="nav flex-column">  https://www.w3schools.com/bootstrap4/bootstrap_navs.asp
        //  <ul className="nav nav-tabs">
        let upperMappingsElem = (
            <div className="separate-upper-mapping-tab">
                <ul className="nav nav-pills">
                    {backendUpperMappingsTabElem}
                    {this.getUpperMappingsTab(
                        this.props.options.type,
                        this.internalConstUpperMappingsMode.tabUpperMappingsFrontend,
                        frontendText,
                        isFrontendDefined,
                        isFrontendDefined_butNotUsed,
                        myUpperMappingsMode
                    )}
                </ul>
                <div className="tab-content">
                    <div className="tab-pane active">{upperMappingsContent}</div>
                </div>
            </div>
        );

        //LL:  separateElem inside, errorsElem outside
        //   { separateElem } is inside upperMappingsElem
        let dlgContent = this.props.options.withMappings ? upperMappingsElem : separateElem;

        return (
            <div className="interval-select">
                <div
                    className={'popover intervals-select-popover ' + popoverStyle.side}
                    ref={(input) => {
                        this.references.popoverContent = input;
                    }}
                    style={{
                        display: 'block',
                        left: popoverStyle.left,
                        top: popoverStyle.top,
                        zIndex: this.props.zIndex
                    }}
                    onClick={this.containerClick}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {popupTitle}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.escapeButtonHandler}
                        >
                            ×
                        </button>
                    </h3>
                    <div className="popover-body">
                        {errorsElem}

                        {dlgContent}
                    </div>
                    <div className="modal-footer">
                        <div className="btn-group" role="group" aria-label="Save Buttons">
                            <button
                                className={'btn btn-success button-confirm' + (errors.length > 0 ? ' disabled' : '')}
                                onClick={this.closeButtonHandler}
                            >
                                {'OK'}
                            </button>
                            <button className="btn btn-default" onClick={this.escapeButtonHandler}>
                                {'Cancel'}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}

function hasTimePartFunc(value, type) {
    let hasTimePart = false;

    if (value != null) {
        if (value.timePart != null && value.timePart != 'none') {
            hasTimePart = true;
        }
    }

    return hasTimePart;
}

export function isUserDefinedInterval(intervals) {
    if (intervals != null) {
        let useIntervalType = intervals.useIntervalType;

        if (useIntervalType == null) {
            useIntervalType = useDateTimeIntervalType.useNone; //LL: 13.04.20  although does not matter here
        }

        if (useIntervalType === useDateTimeIntervalType.useUserDefined) {
            let hasUserDefined = intervals.values != null && intervals.values.length > 0;

            if (intervals.modePredefinedOrOwn === 'UsePredefined') {
                hasUserDefined = intervals.predefinedMapping != null;
            }

            return hasUserDefined;
        }

        return false;
    }

    return false;
}

export function convertIntervalValueToAttrQueryParam(
    intervals: IIntervals,
    utcOffsetFromTheme: ITimeZone,
    attributeType: string,
    theme?: IValuesCollection,
    cultureValues?: Globalization.ICultureValues
): IIntervalParameters {
    let result: IIntervalParameters = {};
    let fiscalStartMonth_default: number;
    let firstWeekDayNumber: number;

    if (cultureValues != null) {
        fiscalStartMonth_default = cultureValues.fiscalFirstMonth;
        firstWeekDayNumber = cultureValues.firstWeekDayNumber;
    } else {
        console.log(
            'WARNING: Culture Values are not specified for convertIntervalValueToAttrQueryParam(). firstWeekDayNumber might be wrong.'
        );

        fiscalStartMonth_default = getFiscalFirstMonthFromTheme(theme);

        if (typeof fiscalStartMonth_default === 'string') {
            let K = parseInt(fiscalStartMonth_default, 10);

            if (!isNaN(K)) {
                fiscalStartMonth_default = K;
            }
        }
    }

    if (fiscalStartMonth_default == null) {
        fiscalStartMonth_default = Globalization.DEFAULT_FISCAL_FIRST_MONTH;
    }

    if (firstWeekDayNumber == null) {
        const firstDay = Globalization.getFirstWeekDay(theme);
        //LL: as "mon" or "sun", by OE regardless on culture, not "пон"

        firstWeekDayNumber = Globalization.weekDayNumber_iso(firstDay); //LL: "sun": 7, "mon": 1, "tue": 2,
    }

    let notEmptyForDates = false;

    //LL: see Charts main.ts:
    if (intervals != null) {
        if (intervals.timePart != null && intervals.timePart !== 'none') {
            result.timePart = intervals.timePart;
            notEmptyForDates = true;

            //LL: timePartStartMonth only for "fiscal"
            if (isFiscalTimePeriod(intervals.timePart)) {
                let timePeriodStartMonth = intervals.timePeriodStartMonth;

                if (timePeriodStartMonth == null) {
                    timePeriodStartMonth = (intervals as any).timePartStartMonth; //EVG 01.06.2020: Obsolete. Drop it.

                    if (timePeriodStartMonth == null) {
                        timePeriodStartMonth = fiscalStartMonth_default;
                    }
                }

                if (typeof timePeriodStartMonth === 'string') {
                    let K = parseInt(timePeriodStartMonth, 10);

                    if (!isNaN(K)) {
                        timePeriodStartMonth = K;
                    } else {
                        timePeriodStartMonth = fiscalStartMonth_default; //LL: 05.03.20,  was 1
                    }
                }

                result.timePeriodStartMonth = timePeriodStartMonth; //LL:  by AG: "startMonth": 4
            }
        }

        //LL: NEW: "useIntervalType" with 3 values instead of useRegularIntervals
        //     useIntervalType is of type enum useDateTimeIntervalType
        let useIntervalType = intervals.useIntervalType;

        if (useIntervalType == null) {
            useIntervalType = useDateTimeIntervalType.useNone;

            //LL: 04.06.18: to consider old (1.5) functionality:
            //LL:  OLD: only 2 alternatives:
            //   By Leo request: send to backend either "regular" or "User Defined"
            let useRegularIntervals = intervals.useRegularIntervals;
            //LL: see also normalize - to remove useRegularIntervals
            if (useRegularIntervals != null) {
                if (useRegularIntervals) {
                    useIntervalType = useDateTimeIntervalType.useRegular;
                } else {
                    useIntervalType = useDateTimeIntervalType.useNone;
                }
            } else {
                if (attributeType != null) {
                    let using = evalUsingIntervals(intervals, attributeType);

                    if (using.useRegular) {
                        useIntervalType = useDateTimeIntervalType.useRegular;
                    } else if (using.useUserDefined) {
                        useIntervalType = useDateTimeIntervalType.useUserDefined;
                    } else if (using.useTimePeriods) {
                        useIntervalType = useDateTimeIntervalType.useTimePeriods;
                    }
                } else {
                    useIntervalType = useDateTimeIntervalType.useRegular;
                }
            }
        }

        let setPeriodPoint = false;

        //LL: 13.04.20: useDateTimeIntervalType.useNone ?  no need here

        switch (useIntervalType) {
            case useDateTimeIntervalType.useRegular:
                //LL: this is "regular"  Date/Time:
                if (intervals.timeIntervals != null) {
                    // VR: WI 55961: Updated  TimeInterval concept
                    let normDate = intervals.timeIntervals.normDate; // for "time"

                    if (attributeType !== ATTRIBUTE_TYPES.TIME) {
                        if (normDate == null || normDate === '') {
                            normDate = '2000-01-01 00:00:00';
                        }

                        normDate = formatDateForIntervalSelect(
                            normDate,
                            'normDate', //EVG 22.02.2022: There is no such type.
                            utcOffsetFromTheme
                        );
                    }

                    result.timeIntervals = {
                        timePart: intervals.timeIntervals.timePart,
                        intervalLength: intervals.timeIntervals.intervalLength,
                        normDate: normDate
                    };

                    setPeriodPoint = true;
                    notEmptyForDates = true;
                }

                //LL: this is "regular" Numeric:
                if (intervals.numberIntervals != null) {
                    result.numberIntervals = {
                        intervalLength: intervals.numberIntervals.intervalLength,
                        normValue: intervals.numberIntervals.normValue
                    };

                    setPeriodPoint = true;
                }
                break;

            case useDateTimeIntervalType.useUserDefined:
                //LL: dates come as strings "2012-01-19" - yy-mm-dd
                let predefinedIntervals;

                if (intervals.modePredefinedOrOwn === 'UsePredefined') {
                    if (intervals.predefinedMapping != null) {
                        // predefinedMapping = {mappingName: val, mappingType: curMappingType};
                        let mapping = intervals.predefinedMapping;
                        let mappingType = mapping.mappingType; //LL: always 'DiscreteMapping'
                        let mapObj: any = null;
                        let mapList = getMappingList(theme, mappingType);

                        if (mapList != null) {
                            mapObj = _.find(mapList, function (m) {
                                return m.name === mapping.mappingName;
                            });

                            if (mapObj != null) {
                                predefinedIntervals = $.extend(true, {}, mapObj.discreteIntervals);
                                delete predefinedIntervals.nullMappedValue;
                            }
                        }
                    }
                }

                let intervalsN: IIntervals = {};

                if (intervals.modePredefinedOrOwn === 'UsePredefined') {
                    if (predefinedIntervals != null) {
                        intervalsN = predefinedIntervals;
                    }
                } else {
                    intervalsN = $.extend(true, {}, intervals);
                }

                if (intervalsN.values != null && intervalsN.values.length > 0) {
                    //LL: not empty "labels":   (and maybe all different ???)
                    //    labels.len = values.len + 1
                    for (let k = 0; k < intervalsN.labels.length; k++) {
                        if (intervalsN.labels[k] == null || intervalsN.labels[k].trim() === '') {
                            let left = k === 0 ? null : intervalsN.values[k - 1];
                            let right = k < intervalsN.values.length ? intervalsN.values[k] : Infinity;

                            intervalsN.labels[k] = getIntervalPlaceholderValue(left, right, attributeType, false);
                        }
                    }

                    const v1 = intervalsN.values[0];

                    let forDates = false;

                    if (typeof v1 == 'string') {
                        let n1 = Date.parse(v1);

                        if (!isNaN(n1)) {
                            forDates = true;
                        }
                    }

                    if (forDates) {
                        //VR: for dates
                        let values = [];

                        intervalsN.values.forEach((value) => {
                            if (typeof value === 'string') {
                                // See Issue 100597.
                                if (attributeType === ATTRIBUTE_TYPES.DATE) {
                                    values.push(value);
                                } else if (attributeType === ATTRIBUTE_TYPES.TIME) {
                                    const tVal = convertTimeValueAsDateToString(value);

                                    values.push(tVal);
                                } else {
                                    const formattedValue = formatDateForIntervalSelect(
                                        value,
                                        attributeType,
                                        utcOffsetFromTheme
                                    );

                                    if (formattedValue != null) {
                                        values.push(formattedValue);
                                    }
                                }
                            }
                        });

                        result.intervals = {
                            labels: intervalsN.labels,
                            values: values
                        };

                        notEmptyForDates = true;
                    } else {
                        // VR: for numbers
                        result.intervals = {
                            labels: intervalsN.labels,
                            values: intervalsN.values
                        };
                    }
                }
                break;

            case useDateTimeIntervalType.useTimePeriods:
                if (intervals.timePeriods != null) {
                    result.timePeriods = {
                        timePeriod: intervals.timePeriods.timePeriod
                    };

                    //LL: timePeriodStartMonth only for "fiscal"
                    //if (isFiscalTimePeriod(intervals.timePeriods.timePeriod)
                    //    && intervals.timePeriods.timePeriodStartMonth != null) {
                    if (isFiscalTimePeriod(intervals.timePeriods.timePeriod)) {
                        let timePeriodStartMonth = intervals.timePeriods.timePeriodStartMonth;

                        if (timePeriodStartMonth == null) {
                            timePeriodStartMonth = fiscalStartMonth_default;
                        }

                        if (typeof timePeriodStartMonth === 'string') {
                            const K = parseInt(timePeriodStartMonth, 10);

                            if (!isNaN(K)) {
                                timePeriodStartMonth = K;
                            } else {
                                timePeriodStartMonth = fiscalStartMonth_default;
                            }
                        }

                        result.timePeriods.timePeriodStartMonth = timePeriodStartMonth;
                    }

                    //AG: "timePeriodTimeZoneAnother":false seems unnecessary.
                    //LL:  set this param only if = true.
                    //LL:  also, maybe, "timePeriodTimeZone":null  id redundant ?  No, means "Browser Default"
                    //LL: 20.06.18: don't send "Browser Default"
                    //     And I'll send always, even if intervals.timePeriods.timePeriodTimeZone is null
                    //
                    //LL: 20.06.18: by AG: ===============
                    //  The following:
                    //
                    //    "timePeriodTimeZoneAnother": true,
                    //    "timePeriodTimeZone": {
                    //        "useOffset": true,
                    //        "offsetName": "Europe/Copenhagen",
                    //        "useCustom": false,
                    //        "customString": "",
                    //        "customMinutes": 0
                    //     }
                    //  should be transferred into this (if time zone is defined):
                    //     “timeZone”: "Europe/Copenhagen"
                    //
                    //  Otherwise you can omit “the following” part.
                    // ====================================

                    if (intervals.timePeriods.timePeriodTimeZoneAnother === true) {
                        //attr.timePeriods.timePeriodTimeZoneAnother = true;
                        //attr.timePeriods.timePeriodTimeZone = intervals.timePeriods.timePeriodTimeZone;  // can be null

                        let tz = intervals.timePeriods.timePeriodTimeZone; // can be null => Browser Default
                        //LL: don't, because "Set different Time Zone than in Theme", and null (=> Browser Default) can be "different"
                        //if (tz == null) {
                        //    tz = utcOffsetFromTheme;
                        //}
                        let tzName = getTimeZoneName(tz);

                        if (tzName != null && tzName !== '') {
                            result.timePeriods.timeZone = tzName;
                            //attr.timePeriods.timePeriodTimeZoneAnother = true;  //LL: no need says AG
                        }
                    }

                    setPeriodPoint = true;
                    notEmptyForDates = true;
                }
                break;
        }

        if (setPeriodPoint && intervals.periodPoint != null) {
            result.periodPoint = intervals.periodPoint;
        }
    }

    if (notEmptyForDates) {
        result.firstWeekDay = firstWeekDayNumber;
    }

    return result;
}

export function IntervalsSelect(props: {
    value;
    type: string;
    notUseRegularTab?: boolean;
    withMappings?: boolean;
    targetTypes?: number[]; //  array of DiscreteIntervalsKind (enum from DiscreteIntervals) or null for any
    mapping?: IMappingValue;
    imageMappingMode?: ImageMappingModeType;
    hideBackendTab?: boolean; // or hideIntervalsTab
    showDescription?: boolean;
    allowFrontendAttributeMapping?: boolean;
    isCountAggregate?: boolean;
    themeObj?: IValuesCollection;
    glob: IGlob;

    onChange(value: IIntervals, withMappings?: boolean, resultingType?): void;
}) {
    const withMappings = props.withMappings ?? false;

    const handleOnChange = (value) => {
        if (typeof props.onChange === 'function') {
            //LL: when withMappings - value is complex object  { intervals: state.value, mapping: mapping }
            //    mapping?: IMappingValue;   IMappingValue_Internal
            if (withMappings === true) {
                let resultingType;

                if (value != null && value.mapping != null) {
                    if (value.mapping.mappingType === 'DiscreteMapping') {
                        if (value.mapping.mappingObj != null) {
                            resultingType = value.mapping.mappingObj.resultingType;
                        }
                    } else if (value.mapping.mappingType === 'ColorScale') {
                        resultingType = DiscreteIntervalsKind.color;
                    }
                    //LL: and there is mappingType = "AttributeMapping"
                    delete value.mapping.mappingObj;
                }

                props.onChange(value, withMappings, resultingType);
            } else {
                // old
                props.onChange(value);
            }
        }
    };

    const handleSelectorShow = (e) => {
        const offset = $(e.target).offset();
        const hideBackendTab = props.hideBackendTab != null ? props.hideBackendTab : false;
        const allowFrontendAttributeMapping = props.allowFrontendAttributeMapping ?? false;
        const isCountAggregate = props.isCountAggregate ?? false;

        let mappingSource: IMappingValue = props.mapping; // IMappingValue => IMappingValue_Internal
        let mapping: IMappingValue_Internal;

        if (mappingSource != null) {
            mapping = _.extend({}, mappingSource, { mappingObj: null });

            let mapObj = null;
            let mapList = getMappingList(props.themeObj, mapping.mappingType);

            if (mapList != null) {
                mapObj = _.find(mapList, function (m) {
                    return m.name === mapping.mappingName;
                });
                if (mapObj != null) {
                    mapObj = $.extend(true, {}, mapObj);
                }
            }

            if (mapObj != null) {
                mapping.mappingObj = mapObj;
            }
        }

        let aType = props.type;

        if (isCountAggregate === true) {
            aType = ATTRIBUTE_TYPES.INTEGER;
        }

        props.glob.DialogActions.createPopup<IIntervalSelectPopupOptions>('custom', {
            top: offset.top,
            left: offset.left,
            value: props.value,
            type: aType,
            notUseRegularTab: props.notUseRegularTab, //IL. To prevent Regular intervals tab. Used in Gis icons
            themeObj: props.themeObj,
            withMappings: withMappings,
            mapping: mapping,
            targetTypes: props.targetTypes,
            imageMappingMode: props.imageMappingMode,
            hideBackendTab: hideBackendTab,
            allowFrontendAttributeMapping: allowFrontendAttributeMapping,
            isCountAggregate: isCountAggregate,

            onChange: handleOnChange, //LL: 11.12.19:  now both for Intervals and Mappings

            component: IntervalSelectPopup
        });
    };

    let value: any = null;
    let title = '';
    let mapping: IMappingValue;

    if (withMappings) {
        mapping = props.mapping;
    }

    if (props.value == null && mapping == null) {
        value = <em className="empty" onClick={handleSelectorShow}></em>;
    } else {
        value = ''; //LL: here value is interpreted as string

        if (props.value != null) {
            const using = evalUsingIntervals(props.value, props.type);
            const useRegular = using.useRegular;
            const useUserDefined = using.useUserDefined;
            const useTimePeriods = using.useTimePeriods;

            if (useRegular && props.value.numberIntervals != null && props.value.numberIntervals.intervalLength != 0) {
                let intLength = props.value.numberIntervals.intervalLength;
                let intValue = props.value.numberIntervals.normValue;

                value += (value == '' ? '' : '; ') + intValue.toString() + '(' + intLength.toString() + ')';
                title += (title == '' ? '' : '; ') + 'Regular Interval';
            }

            if (useRegular && props.value.timeIntervals != null && props.value.timeIntervals.timePart != 'none') {
                let tPart = props.value.timeIntervals.timePart;

                if (tPart == null && props.value.timeIntervals.timeEntity != null) {
                    tPart = props.value.timeIntervals.timeEntity;
                }

                value += (value == '' ? '' : '; ') + tPart + ':' + props.value.timeIntervals.intervalLength.toString();
                title += (title == '' ? '' : '; ') + 'Regular Interval';
            }

            //if (useUserDefined && props.value.values != null && props.value.values.length > 0) {
            //    let valuesText = props.value.values.join(', ');
            //
            //    if (props.type === 'time') {
            //        let times = _.map(props.value.values, (dateString: string) => {
            //            dateString = convertTimeValueAsDateToString(dateString);
            //            return dateString;
            //        });
            //
            //        valuesText = times.join(', ');
            //    }
            //
            //    value += (value == '' ? '' : '; ') + valuesText;
            //
            //    title += (title == '' ? '' : '; ') + 'User Defined Intervals ' + props.value.labels.join(', ');
            //}
            //LL: 02.11.23:
            if (useUserDefined) {
                if (props.value.modePredefinedOrOwn === 'UsePredefined') {
                    let mappingName = '';
                    if (props.value.predefinedMapping != null && props.value.predefinedMapping.mappingName != null) {
                        mappingName = props.value.predefinedMapping.mappingName;
                    }
                    value += (value == '' ? '' : '; ') + mappingName;
                    title += (title == '' ? '' : '; ') + 'User Defined Intervals: mapping "' + mappingName + '"';
                } else if (props.value.values != null && props.value.values.length > 0) {
                    let valuesText = props.value.values.join(', ');

                    if (props.type === 'time') {
                        let times = _.map(props.value.values, (dateString: string) => {
                            dateString = convertTimeValueAsDateToString(dateString);
                            return dateString;
                        });

                        valuesText = times.join(', ');
                    }

                    value += (value == '' ? '' : '; ') + valuesText;
                    title += (title == '' ? '' : '; ') + 'User Defined Intervals ' + props.value.labels.join(', ');
                }
            }

            if (useTimePeriods && props.value.timePeriods != null && props.value.timePeriods.timePeriod != 'none') {
                value += (value == '' ? '' : '; ') + props.value.timePeriods.timePeriod;
                title += (title == '' ? '' : '; ') + 'Calendar Period'; //"Time Period";
            }

            if (props.value.timePart != null && props.value.timePart != 'none') {
                value += (value == '' ? '' : '; ') + props.value.timePart + '(TimePart)';
                title += (title == '' ? '' : '; ') + 'Time Part: ' + props.value.timePart;
            }
        }

        if (mapping != null) {
            title += ' \nmapping: ' + mapping.mappingName;
        }

        if (value !== '' || mapping != null) {
            value = (
                <span
                    className="intervals-button glyphicon glyphicon-equalizer"
                    title={title}
                    style={{ cursor: 'pointer' }}
                    onClick={handleSelectorShow}
                ></span>
            );
        }
    }

    let placeElem = (
        <span className="select-mapping" title={title}>
            {value}
        </span>
    );

    let textElem;

    if (props.showDescription === true) {
        if (mapping != null) {
            let tt = mapping.mappingType + ': "' + mapping.mappingName + '"';
            let mapObj = null;
            let mapList = getMappingList(props.themeObj, mapping.mappingType);

            if (mapList != null) {
                mapObj = _.find(mapList, function (m) {
                    return m.name === mapping.mappingName;
                });

                if (mapObj != null) {
                    let mappType: any;
                    if (mapObj.resultingType != null) {
                        // for DiscreteMapping
                        mappType = mapObj.resultingType;
                        mappType = DiscreteIntervalsKind_toString(mappType);
                    } else {
                        // for ColorScale
                        mappType = 'color';
                    }
                    tt += ' ; mapped type: ' + mappType;
                }
            }

            textElem = <span className="select-mapping">{tt}</span>;
            placeElem = null;
        }
    }

    return (
        <div className="intervals-select-field">
            <div className="content">
                <span
                    className="intervals-button glyphicon glyphicon-cog"
                    title={title}
                    style={{ cursor: 'pointer' }}
                    onClick={handleSelectorShow}
                ></span>
                {placeElem}
                {textElem}
            </div>
        </div>
    );
}
